/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 66);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(23)('wks');
var uid = __webpack_require__(21);
var Symbol = __webpack_require__(4).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = jQuery;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(53);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),
/* 4 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 5 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.12' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(10);
var IE8_DOM_DEFINE = __webpack_require__(34);
var toPrimitive = __webpack_require__(30);
var dP = Object.defineProperty;

exports.f = __webpack_require__(7) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(19)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 8 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(6);
var createDesc = __webpack_require__(12);
module.exports = __webpack_require__(7) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(11);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 11 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 12 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 13 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(45);
var defined = __webpack_require__(17);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(4);
var core = __webpack_require__(5);
var ctx = __webpack_require__(28);
var hide = __webpack_require__(9);
var has = __webpack_require__(8);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 16 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 17 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 18 */
/***/ (function(module, exports) {

module.exports = true;


/***/ }),
/* 19 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(23)('keys');
var uid = __webpack_require__(21);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 21 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 22 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(5);
var global = __webpack_require__(4);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(18) ? 'pure' : 'global',
  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 24 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(6).f;
var has = __webpack_require__(8);
var TAG = __webpack_require__(0)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(17);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(41)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(33)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(42);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(11);
var document = __webpack_require__(4).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(11);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(37);
var enumBugKeys = __webpack_require__(24);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(16);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(18);
var $export = __webpack_require__(15);
var redefine = __webpack_require__(35);
var hide = __webpack_require__(9);
var Iterators = __webpack_require__(13);
var $iterCreate = __webpack_require__(43);
var setToStringTag = __webpack_require__(25);
var getPrototypeOf = __webpack_require__(49);
var ITERATOR = __webpack_require__(0)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(7) && !__webpack_require__(19)(function () {
  return Object.defineProperty(__webpack_require__(29)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(9);


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(10);
var dPs = __webpack_require__(44);
var enumBugKeys = __webpack_require__(24);
var IE_PROTO = __webpack_require__(20)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(29)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(48).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(8);
var toIObject = __webpack_require__(14);
var arrayIndexOf = __webpack_require__(46)(false);
var IE_PROTO = __webpack_require__(20)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(56), __esModule: true };

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(61);
var ITERATOR = __webpack_require__(0)('iterator');
var Iterators = __webpack_require__(13);
module.exports = __webpack_require__(5).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(68);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(73);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(16);
var defined = __webpack_require__(17);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 42 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(36);
var descriptor = __webpack_require__(12);
var setToStringTag = __webpack_require__(25);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(9)(IteratorPrototype, __webpack_require__(0)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(6);
var anObject = __webpack_require__(10);
var getKeys = __webpack_require__(31);

module.exports = __webpack_require__(7) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(22);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(14);
var toLength = __webpack_require__(32);
var toAbsoluteIndex = __webpack_require__(47);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(16);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(4).document;
module.exports = document && document.documentElement;


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(8);
var toObject = __webpack_require__(26);
var IE_PROTO = __webpack_require__(20)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(0);


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(4);
var core = __webpack_require__(5);
var LIBRARY = __webpack_require__(18);
var wksExt = __webpack_require__(50);
var defineProperty = __webpack_require__(6).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 52 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(54), __esModule: true };

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(55);
var $Object = __webpack_require__(5).Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(15);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(7), 'Object', { defineProperty: __webpack_require__(6).f });


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(27);
__webpack_require__(57);
module.exports = __webpack_require__(5).Array.from;


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(28);
var $export = __webpack_require__(15);
var toObject = __webpack_require__(26);
var call = __webpack_require__(58);
var isArrayIter = __webpack_require__(59);
var toLength = __webpack_require__(32);
var createProperty = __webpack_require__(60);
var getIterFn = __webpack_require__(39);

$export($export.S + $export.F * !__webpack_require__(62)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(10);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(13);
var ITERATOR = __webpack_require__(0)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(6);
var createDesc = __webpack_require__(12);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(22);
var TAG = __webpack_require__(0)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(0)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(70);
var global = __webpack_require__(4);
var hide = __webpack_require__(9);
var Iterators = __webpack_require__(13);
var TO_STRING_TAG = __webpack_require__(0)('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),
/* 64 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(37);
var hiddenKeys = __webpack_require__(24).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(67);var _theme=__webpack_require__(84);var _theme2=_interopRequireDefault(_theme);__webpack_require__(107);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}// Export the theme controller for global usage.
/**
 * Theme JS building
 */// This is used to watch for changes in *.hbs files in the styles directory.
// This way the styleguide automatically gets regenerated when handlebars template file is changed.
//function requireAll( r ) {
//    r.keys().forEach( r );
//}
// requireAll( require.context( '../styles/', true, /\.hbs$/ ) );
window.Theme=_theme2.default;// Require main style file here for concatenation.

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _typeof2=__webpack_require__(40);var _typeof3=_interopRequireDefault(_typeof2);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/* eslint-disable *//*! modernizr 3.5.0 (Custom Build) | MIT *
 * https://modernizr.com/download/?-backgroundblendmode-boxsizing-checked-cssanimations-csscalc-cssfilters-cssgradients-cssgrid_cssgridlegacy-cssinvalid-cssmask-csspointerevents-csspositionsticky-cssremunit-cssscrollbar-csstransforms-cssvhunit-cssvmaxunit-cssvminunit-cssvwunit-ellipsis-flexbox-fontface-mediaqueries-multiplebgs-nthchild-objectfit-rgba-supports-svg-svgasimg-svgfilters-target-willchange-setclasses !*/!function(e,t,n){function r(e,t){return(typeof e==="undefined"?"undefined":(0,_typeof3.default)(e))===t;}function i(){var e,t,n,i,s,o,a;for(var l in b){if(b.hasOwnProperty(l)){if(e=[],t=b[l],t.name&&(e.push(t.name.toLowerCase()),t.options&&t.options.aliases&&t.options.aliases.length))for(n=0;n<t.options.aliases.length;n++){e.push(t.options.aliases[n].toLowerCase());}for(i=r(t.fn,"function")?t.fn():t.fn,s=0;s<e.length;s++){o=e[s],a=o.split("."),1===a.length?Modernizr[a[0]]=i:(!Modernizr[a[0]]||Modernizr[a[0]]instanceof Boolean||(Modernizr[a[0]]=new Boolean(Modernizr[a[0]])),Modernizr[a[0]][a[1]]=i),T.push((i?"":"no-")+a.join("-"));}}}}function s(e){var t=z.className,n=Modernizr._config.classPrefix||"";if(k&&(t=t.baseVal),Modernizr._config.enableJSClass){var r=new RegExp("(^|\\s)"+n+"no-js(\\s|$)");t=t.replace(r,"$1"+n+"js$2");}Modernizr._config.enableClasses&&(t+=" "+n+e.join(" "+n),k?z.className.baseVal=t:z.className=t);}function o(){return"function"!=typeof t.createElement?t.createElement(arguments[0]):k?t.createElementNS.call(t,"http://www.w3.org/2000/svg",arguments[0]):t.createElement.apply(t,arguments);}function a(t,n,r){var i;if("getComputedStyle"in e){i=getComputedStyle.call(e,t,n);var s=e.console;if(null!==i)r&&(i=i.getPropertyValue(r));else if(s){var o=s.error?"error":"log";s[o].call(s,"getComputedStyle returning null, its possible modernizr test results are inaccurate");}}else i=!n&&t.currentStyle&&t.currentStyle[r];return i;}function l(e,t){return e-1===t||e===t||e+1===t;}function d(e){return e.replace(/([a-z])-([a-z])/g,function(e,t,n){return t+n.toUpperCase();}).replace(/^-/,"");}function u(e,t){if("object"==(typeof e==="undefined"?"undefined":(0,_typeof3.default)(e)))for(var n in e){N(e,n)&&u(n,e[n]);}else{e=e.toLowerCase();var r=e.split("."),i=Modernizr[r[0]];if(2==r.length&&(i=i[r[1]]),"undefined"!=typeof i)return Modernizr;t="function"==typeof t?t():t,1==r.length?Modernizr[r[0]]=t:(!Modernizr[r[0]]||Modernizr[r[0]]instanceof Boolean||(Modernizr[r[0]]=new Boolean(Modernizr[r[0]])),Modernizr[r[0]][r[1]]=t),s([(t&&0!=t?"":"no-")+r.join("-")]),Modernizr._trigger(e,t);}return Modernizr;}function c(){var e=t.body;return e||(e=o(k?"svg":"body"),e.fake=!0),e;}function f(e,n,r,i){var s,a,l,d,u="modernizr",f=o("div"),p=c();if(parseInt(r,10))for(;r--;){l=o("div"),l.id=i?i[r]:u+(r+1),f.appendChild(l);}return s=o("style"),s.type="text/css",s.id="s"+u,(p.fake?p:f).appendChild(s),p.appendChild(f),s.styleSheet?s.styleSheet.cssText=e:s.appendChild(t.createTextNode(e)),f.id=u,p.fake&&(p.style.background="",p.style.overflow="hidden",d=z.style.overflow,z.style.overflow="hidden",z.appendChild(p)),a=n(f,e),p.fake?(p.parentNode.removeChild(p),z.style.overflow=d,z.offsetHeight):f.parentNode.removeChild(f),!!a;}function p(e,t){return!!~(""+e).indexOf(t);}function h(e,t){return function(){return e.apply(t,arguments);};}function m(e,t,n){var i;for(var s in e){if(e[s]in t)return n===!1?e[s]:(i=t[e[s]],r(i,"function")?h(i,n||t):i);}return!1;}function g(e){return e.replace(/([A-Z])/g,function(e,t){return"-"+t.toLowerCase();}).replace(/^ms-/,"-ms-");}function v(t,r){var i=t.length;if("CSS"in e&&"supports"in e.CSS){for(;i--;){if(e.CSS.supports(g(t[i]),r))return!0;}return!1;}if("CSSSupportsRule"in e){for(var s=[];i--;){s.push("("+g(t[i])+":"+r+")");}return s=s.join(" or "),f("@supports ("+s+") { #modernizr { position: absolute; } }",function(e){return"absolute"==a(e,null,"position");});}return n;}function y(e,t,i,s){function a(){u&&(delete q.style,delete q.modElem);}if(s=r(s,"undefined")?!1:s,!r(i,"undefined")){var l=v(e,i);if(!r(l,"undefined"))return l;}for(var u,c,f,h,m,g=["modernizr","tspan","samp"];!q.style&&g.length;){u=!0,q.modElem=o(g.shift()),q.style=q.modElem.style;}for(f=e.length,c=0;f>c;c++){if(h=e[c],m=q.style[h],p(h,"-")&&(h=d(h)),q.style[h]!==n){if(s||r(i,"undefined"))return a(),"pfx"==t?h:!0;try{q.style[h]=i;}catch(y){}if(q.style[h]!=m)return a(),"pfx"==t?h:!0;}}return a(),!1;}function x(e,t,n,i,s){var o=e.charAt(0).toUpperCase()+e.slice(1),a=(e+" "+P.join(o+" ")+o).split(" ");return r(t,"string")||r(t,"undefined")?y(a,t,i,s):(a=(e+" "+M.join(o+" ")+o).split(" "),m(a,t,n));}function w(e,t,r){return x(e,n,n,t,r);}var T=[],b=[],S={_version:"3.5.0",_config:{classPrefix:"",enableClasses:!0,enableJSClass:!0,usePrefixes:!0},_q:[],on:function on(e,t){var n=this;setTimeout(function(){t(n[e]);},0);},addTest:function addTest(e,t,n){b.push({name:e,fn:t,options:n});},addAsyncTest:function addAsyncTest(e){b.push({name:null,fn:e});}},Modernizr=function Modernizr(){};Modernizr.prototype=S,Modernizr=new Modernizr(),Modernizr.addTest("svg",!!t.createElementNS&&!!t.createElementNS("http://www.w3.org/2000/svg","svg").createSVGRect);var C="CSS"in e&&"supports"in e.CSS,_="supportsCSS"in e;Modernizr.addTest("supports",C||_),Modernizr.addTest("target",function(){var t=e.document;if(!("querySelectorAll"in t))return!1;try{return t.querySelectorAll(":target"),!0;}catch(n){return!1;}}),Modernizr.addTest("svgfilters",function(){var t=!1;try{t="SVGFEColorMatrixElement"in e&&2==SVGFEColorMatrixElement.SVG_FECOLORMATRIX_TYPE_SATURATE;}catch(n){}return t;});var z=t.documentElement;Modernizr.addTest("willchange","willChange"in z.style);var k="svg"===z.nodeName.toLowerCase();Modernizr.addTest("multiplebgs",function(){var e=o("a").style;return e.cssText="background:url(https://),url(https://),red url(https://)",/(url\s*\(.*?){3}/.test(e.background);}),Modernizr.addTest("csspointerevents",function(){var e=o("a").style;return e.cssText="pointer-events:auto","auto"===e.pointerEvents;}),Modernizr.addTest("cssremunit",function(){var e=o("a").style;try{e.fontSize="3rem";}catch(t){}return /rem/.test(e.fontSize);}),Modernizr.addTest("rgba",function(){var e=o("a").style;return e.cssText="background-color:rgba(150,255,150,.5)",(""+e.backgroundColor).indexOf("rgba")>-1;});var E=S._config.usePrefixes?" -webkit- -moz- -o- -ms- ".split(" "):["",""];S._prefixes=E,Modernizr.addTest("csscalc",function(){var e="width:",t="calc(10px);",n=o("a");return n.style.cssText=e+E.join(t+e),!!n.style.length;}),Modernizr.addTest("cssgradients",function(){for(var e,t="background-image:",n="gradient(linear,left top,right bottom,from(#9f9),to(white));",r="",i=0,s=E.length-1;s>i;i++){e=0===i?"to ":"",r+=t+E[i]+"linear-gradient("+e+"left top, #9f9, white);";}Modernizr._config.usePrefixes&&(r+=t+"-webkit-"+n);var a=o("a"),l=a.style;return l.cssText=r,(""+l.backgroundImage).indexOf("gradient")>-1;}),Modernizr.addTest("csspositionsticky",function(){var e="position:",t="sticky",n=o("a"),r=n.style;return r.cssText=e+E.join(t+";"+e).slice(0,-e.length),-1!==r.position.indexOf(t);});var N;!function(){var e={}.hasOwnProperty;N=r(e,"undefined")||r(e.call,"undefined")?function(e,t){return t in e&&r(e.constructor.prototype[t],"undefined");}:function(t,n){return e.call(t,n);};}(),S._l={},S.on=function(e,t){this._l[e]||(this._l[e]=[]),this._l[e].push(t),Modernizr.hasOwnProperty(e)&&setTimeout(function(){Modernizr._trigger(e,Modernizr[e]);},0);},S._trigger=function(e,t){if(this._l[e]){var n=this._l[e];setTimeout(function(){var e,r;for(e=0;e<n.length;e++){(r=n[e])(t);}},0),delete this._l[e];}},Modernizr._q.push(function(){S.addTest=u;}),Modernizr.addTest("svgasimg",t.implementation.hasFeature("http://www.w3.org/TR/SVG11/feature#Image","1.1"));var j=S.testStyles=f;Modernizr.addTest("checked",function(){return j("#modernizr {position:absolute} #modernizr input {margin-left:10px} #modernizr :checked {margin-left:20px;display:block}",function(e){var t=o("input");return t.setAttribute("type","checkbox"),t.setAttribute("checked","checked"),e.appendChild(t),20===t.offsetLeft;});});var A=function(){var e=navigator.userAgent,t=e.match(/w(eb)?osbrowser/gi),n=e.match(/windows phone/gi)&&e.match(/iemobile\/([0-9])+/gi)&&parseFloat(RegExp.$1)>=9;return t||n;}();A?Modernizr.addTest("fontface",!1):j('@font-face {font-family:"font";src:url("https://")}',function(e,n){var r=t.getElementById("smodernizr"),i=r.sheet||r.styleSheet,s=i?i.cssRules&&i.cssRules[0]?i.cssRules[0].cssText:i.cssText||"":"",o=/src/i.test(s)&&0===s.indexOf(n.split(" ")[0]);Modernizr.addTest("fontface",o);}),Modernizr.addTest("cssinvalid",function(){return j("#modernizr input{height:0;border:0;padding:0;margin:0;width:10px} #modernizr input:invalid{width:50px}",function(e){var t=o("input");return t.required=!0,e.appendChild(t),t.clientWidth>10;});}),j("#modernizr div {width:1px} #modernizr div:nth-child(2n) {width:2px;}",function(e){for(var t=e.getElementsByTagName("div"),n=!0,r=0;5>r;r++){n=n&&t[r].offsetWidth===r%2+1;}Modernizr.addTest("nthchild",n);},5),j("#modernizr{overflow: scroll; width: 40px; height: 40px; }#"+E.join("scrollbar{width:10px} #modernizr::").split("#").slice(1).join("#")+"scrollbar{width:10px}",function(e){Modernizr.addTest("cssscrollbar","scrollWidth"in e&&30==e.scrollWidth);}),j("#modernizr { height: 50vh; }",function(t){var n=parseInt(e.innerHeight/2,10),r=parseInt(a(t,null,"height"),10);Modernizr.addTest("cssvhunit",r==n);}),j("#modernizr1{width: 50vmax}#modernizr2{width:50px;height:50px;overflow:scroll}#modernizr3{position:fixed;top:0;left:0;bottom:0;right:0}",function(e){var t=e.childNodes[2],n=e.childNodes[1],r=e.childNodes[0],i=parseInt((n.offsetWidth-n.clientWidth)/2,10),s=r.clientWidth/100,o=r.clientHeight/100,d=parseInt(50*Math.max(s,o),10),u=parseInt(a(t,null,"width"),10);Modernizr.addTest("cssvmaxunit",l(d,u)||l(d,u-i));},3),j("#modernizr1{width: 50vm;width:50vmin}#modernizr2{width:50px;height:50px;overflow:scroll}#modernizr3{position:fixed;top:0;left:0;bottom:0;right:0}",function(e){var t=e.childNodes[2],n=e.childNodes[1],r=e.childNodes[0],i=parseInt((n.offsetWidth-n.clientWidth)/2,10),s=r.clientWidth/100,o=r.clientHeight/100,d=parseInt(50*Math.min(s,o),10),u=parseInt(a(t,null,"width"),10);Modernizr.addTest("cssvminunit",l(d,u)||l(d,u-i));},3),j("#modernizr { width: 50vw; }",function(t){var n=parseInt(e.innerWidth/2,10),r=parseInt(a(t,null,"width"),10);Modernizr.addTest("cssvwunit",r==n);});var I=function(){var t=e.matchMedia||e.msMatchMedia;return t?function(e){var n=t(e);return n&&n.matches||!1;}:function(t){var n=!1;return f("@media "+t+" { #modernizr { position: absolute; } }",function(t){n="absolute"==(e.getComputedStyle?e.getComputedStyle(t,null):t.currentStyle).position;}),n;};}();S.mq=I,Modernizr.addTest("mediaqueries",I("only all"));var O="Moz O ms Webkit",P=S._config.usePrefixes?O.split(" "):[];S._cssomPrefixes=P;var R=function R(t){var r,i=E.length,s=e.CSSRule;if("undefined"==typeof s)return n;if(!t)return!1;if(t=t.replace(/^@/,""),r=t.replace(/-/g,"_").toUpperCase()+"_RULE",r in s)return"@"+t;for(var o=0;i>o;o++){var a=E[o],l=a.toUpperCase()+"_"+r;if(l in s)return"@-"+a.toLowerCase()+"-"+t;}return!1;};S.atRule=R;var M=S._config.usePrefixes?O.toLowerCase().split(" "):[];S._domPrefixes=M;var W={elem:o("modernizr")};Modernizr._q.push(function(){delete W.elem;});var q={style:W.elem.style};Modernizr._q.unshift(function(){delete q.style;}),S.testAllProps=x,S.testAllProps=w,Modernizr.addTest("cssanimations",w("animationName","a",!0)),Modernizr.addTest("boxsizing",w("boxSizing","border-box",!0)&&(t.documentMode===n||t.documentMode>7)),Modernizr.addTest("cssgridlegacy",w("grid-columns","10px",!0)),Modernizr.addTest("cssgrid",w("grid-template-rows","none",!0)),Modernizr.addTest("ellipsis",w("textOverflow","ellipsis")),Modernizr.addTest("cssfilters",function(){if(Modernizr.supports)return w("filter","blur(2px)");var e=o("a");return e.style.cssText=E.join("filter:blur(2px); "),!!e.style.length&&(t.documentMode===n||t.documentMode>9);}),Modernizr.addTest("flexbox",w("flexBasis","1px",!0)),Modernizr.addTest("cssmask",w("maskRepeat","repeat-x",!0)),Modernizr.addTest("csstransforms",function(){return-1===navigator.userAgent.indexOf("Android 2.")&&w("transform","scale(1)",!0);});var L=S.prefixed=function(e,t,n){return 0===e.indexOf("@")?R(e):(-1!=e.indexOf("-")&&(e=d(e)),t?x(e,t,n):x(e,"pfx"));};Modernizr.addTest("backgroundblendmode",L("backgroundBlendMode","text")),Modernizr.addTest("objectfit",!!L("objectFit"),{aliases:["object-fit"]}),i(),s(T),delete S.addTest,delete S.addAsyncTest;for(var V=0;V<Modernizr._q.length;V++){Modernizr._q[V]();}e.Modernizr=Modernizr;}(window,document);/* eslint-enable */

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(69), __esModule: true };

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(27);
__webpack_require__(63);
module.exports = __webpack_require__(50).f('iterator');


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(71);
var step = __webpack_require__(72);
var Iterators = __webpack_require__(13);
var toIObject = __webpack_require__(14);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(33)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 71 */
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),
/* 72 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(74), __esModule: true };

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(75);
__webpack_require__(81);
__webpack_require__(82);
__webpack_require__(83);
module.exports = __webpack_require__(5).Symbol;


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(4);
var has = __webpack_require__(8);
var DESCRIPTORS = __webpack_require__(7);
var $export = __webpack_require__(15);
var redefine = __webpack_require__(35);
var META = __webpack_require__(76).KEY;
var $fails = __webpack_require__(19);
var shared = __webpack_require__(23);
var setToStringTag = __webpack_require__(25);
var uid = __webpack_require__(21);
var wks = __webpack_require__(0);
var wksExt = __webpack_require__(50);
var wksDefine = __webpack_require__(51);
var enumKeys = __webpack_require__(77);
var isArray = __webpack_require__(78);
var anObject = __webpack_require__(10);
var isObject = __webpack_require__(11);
var toObject = __webpack_require__(26);
var toIObject = __webpack_require__(14);
var toPrimitive = __webpack_require__(30);
var createDesc = __webpack_require__(12);
var _create = __webpack_require__(36);
var gOPNExt = __webpack_require__(79);
var $GOPD = __webpack_require__(80);
var $GOPS = __webpack_require__(64);
var $DP = __webpack_require__(6);
var $keys = __webpack_require__(31);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(65).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(52).f = $propertyIsEnumerable;
  $GOPS.f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(18)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });

$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return $GOPS.f(toObject(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(9)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(21)('meta');
var isObject = __webpack_require__(11);
var has = __webpack_require__(8);
var setDesc = __webpack_require__(6).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(19)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(31);
var gOPS = __webpack_require__(64);
var pIE = __webpack_require__(52);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(22);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(14);
var gOPN = __webpack_require__(65).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(52);
var createDesc = __webpack_require__(12);
var toIObject = __webpack_require__(14);
var toPrimitive = __webpack_require__(30);
var has = __webpack_require__(8);
var IE8_DOM_DEFINE = __webpack_require__(34);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(7) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 81 */
/***/ (function(module, exports) {



/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(51)('asyncIterator');


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(51)('observable');


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(jQuery) {var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(3);var _createClass3=_interopRequireDefault(_createClass2);var _common=__webpack_require__(85);var _common2=_interopRequireDefault(_common);var _menu=__webpack_require__(87);var _menu2=_interopRequireDefault(_menu);var _loadMore=__webpack_require__(89);var _loadMore2=_interopRequireDefault(_loadMore);var _accordion=__webpack_require__(90);var _accordion2=_interopRequireDefault(_accordion);var _filter=__webpack_require__(91);var _filter2=_interopRequireDefault(_filter);var _viewportVisibility=__webpack_require__(92);var _viewportVisibility2=_interopRequireDefault(_viewportVisibility);var _imageGallery=__webpack_require__(94);var _imageGallery2=_interopRequireDefault(_imageGallery);var _mapsSection=__webpack_require__(97);var _mapsSection2=_interopRequireDefault(_mapsSection);var _fbResize=__webpack_require__(98);var _fbResize2=_interopRequireDefault(_fbResize);var _comments=__webpack_require__(99);var _comments2=_interopRequireDefault(_comments);var _subscribe=__webpack_require__(100);var _subscribe2=_interopRequireDefault(_subscribe);var _blogTool=__webpack_require__(101);var _blogTool2=_interopRequireDefault(_blogTool);var _tables=__webpack_require__(102);var _tables2=_interopRequireDefault(_tables);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}// Require global controllers.
// Uncomment if Modal needed. Also remember to add `Modal` to the globalControllers.
// import Modal from './modal';
var globalControllers={Common:_common2.default,Menu:_menu2.default,LoadMore:_loadMore2.default,Accordion:_accordion2.default,Filter:_filter2.default,ViewportVisibility:_viewportVisibility2.default,Comments:_comments2.default,Subscribe:_subscribe2.default,ImageGallery:_imageGallery2.default,BlogTool:_blogTool2.default,Tables:_tables2.default};// Require theme controllers.
var templateControllers={MapsSection:_mapsSection2.default,FbResize:_fbResize2.default};/**
 * Class Theme
 *
 * This singleton controls theme's JS class running.
 */var Theme=function(){/**
     * The constructor creates the singleton and binds the docready event.
     *
     * @return {object / void} Either the instance of the class or nothing.
     */function Theme(){var _this=this;(0,_classCallCheck3.default)(this,Theme);if(instance){return instance;}// Initialize the controller maps.
this._templateControllers={};this._globalControllers={};// Load controllers.
this.setGlobalControllers();this.setTemplateControllers();this.init();// Bind run controllers on document ready.
document.addEventListener('DOMContentLoaded',function(e){return _this.runDocReady(e);});var instance=this;}(0,_createClass3.default)(Theme,[{key:'init',/**
     * Runs the 'init' function for all included scripts.
     */value:function init(){// Run all global scripts.
for(var className in this._globalControllers){if(typeof this._globalControllers[className].init==='function'){this._globalControllers[className].init();}}// Run template-specific scripts
for(var _className in this._templateControllers){if(Theme.documentHasClass(_className)&&typeof this._templateControllers[_className].init==='function'){this._templateControllers[_className].init();}}}/**
     * A getter for all controllers.
     *
     * @return {object} A hash map of all controllers.
     */},{key:'getController',/**
     * This method returns a controller by its class name if it is found.
     *
     * @param  {string} name The class name of a controller.
     * @return {object|boolean} The controller instance or false if not found.
     */value:function getController(name){if(typeof this._globalControllers[name]!=='undefined'){return this._globalControllers[name];}else if(typeof this._templateControllers[name]!=='undefined'){return this._templateControllers[name];}else{return false;}}/**
     * Set the globally run scripts.
     */},{key:'setGlobalControllers',value:function setGlobalControllers(){if(globalControllers){for(var className in globalControllers){// Skip non-function iterations.
if(typeof globalControllers[className]!=='function'){continue;}// Set the class reference as a property under the Theme instance.
this[className]=globalControllers[className];// Construct the class and set it under the class property.
this._globalControllers[className]=new globalControllers[className]();}}}/**
     * Set the template specific scripts.
     */},{key:'setTemplateControllers',value:function setTemplateControllers(){if(templateControllers){for(var className in templateControllers){// Set the template's controller only if the class is defined properly
// and the current view has the same class name.
if(typeof templateControllers[className]=='function'&&Theme.documentHasClass(className)){// Set the class reference as a property under the Theme instance.
this[className]=templateControllers[className];// Construct the class and set it under the class property.
this._templateControllers[className]=new templateControllers[className]();}}}}/**
     * Run theme scripts for the html elements class list.
     */},{key:'runDocReady',value:function runDocReady(){// Run all global scripts
for(var className in this._globalControllers){if(typeof this._globalControllers[className].docReady==='function'){this._globalControllers[className].docReady();}}// Run template-specific scripts
for(var _className2 in this._templateControllers){if(Theme.documentHasClass(_className2)&&typeof this._templateControllers[_className2].docReady==='function'){this._templateControllers[_className2].docReady();}}this.addDataCmdListener();}/**
     * Check wheather the body has the given class.
     *
     * @param {string} docClass The body class string.
     */},{key:'findCmdAttribute',/**
     * Finds parent element with data-cmd attribute.
     *
     * @param {object} Target element.
     */value:function findCmdAttribute(element){var cmdAttr=void 0,cmdCtrl=void 0,hrefAttr=void 0;var foundAttr=false;var foundLink=false;while(element&&element.nodeName&&element.getAttribute){// Find data-cmds
if(!foundAttr){cmdAttr=element.getAttribute('data-cmd');cmdCtrl=element.getAttribute('data-ctrl');if(cmdAttr&&cmdCtrl){foundAttr={cid:cmdAttr,el:element,ctrl:cmdCtrl};}}// Find links
if(!foundLink){hrefAttr=element.getAttribute('href');if(hrefAttr){foundLink={href:hrefAttr,el:element};}}element=element.parentNode;}if(foundAttr){return{cmd:foundAttr,link:foundLink};}else{return false;}}/**
     * Add global listener to listen click events. If clicked dom element or parent node
     * has data-cmd and data-ctrl attributes, call the corresponding method
     * in defined controller, if exists.
     */},{key:'addDataCmdListener',value:function addDataCmdListener(){var _this2=this;jQuery(document).on('click',function(e){var captured=_this2.findCmdAttribute(e.target);if(captured){var command=captured.cmd.cid;var controllerName=captured.cmd.ctrl;var controllerInstance=_this2.getController(controllerName);if(controllerInstance&&typeof controllerInstance[command]==='function'){_this2.Common.stop(e);// Set the captured element as the second parameter of the command method.
controllerInstance[command].call(controllerInstance,e,captured.cmd.el);}}});}},{key:'controllers',get:function get(){return this._templateControllers.concat(this._globalControllers);}}],[{key:'documentHasClass',value:function documentHasClass(docClass){return document.documentElement.classList.contains(docClass);}}]);return Theme;}();module.exports=new Theme();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(jQuery) {var _from=__webpack_require__(38);var _from2=_interopRequireDefault(_from);var _toConsumableArray2=__webpack_require__(86);var _toConsumableArray3=_interopRequireDefault(_toConsumableArray2);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(3);var _createClass3=_interopRequireDefault(_createClass2);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/**
 * Common JS controller.
 *
 * Use this class to run scripts globally and to provide
 * modular helper functions for other scripts classes.
 */// Use jQuery as $ within this file scope.
var $=jQuery;/**
 * Class Common
 */var Common=function(){/**
     * Class constructor is for binding class properties.
     */function Common(){(0,_classCallCheck3.default)(this,Common);}/**
     * Cache dom elements for use in the class's methods
     */(0,_createClass3.default)(Common,[{key:'cache',value:function cache(){// The accessible outline style container.
this.focusStyleContainer=document.getElementById('accessible-outline');// Scroll to links. Used for animated internal linking.
this.$scrollToLink=$('.js-scroll-to');// Outgoing links
this.linksInNewTab=document.querySelectorAll('a[target="_blank"]:not(.some-circle):not(.cookiebot-helper-placeholder__link)');// Links in wysiwyg content with external links
var contentLinks=document.querySelectorAll('.wysiwyg a:not(.cookiebot-helper-placeholder__link)');this.externalLinks=[].concat((0,_toConsumableArray3.default)(contentLinks)).filter(function(link){var hostName=link.hostname;if(hostName){// Get links where hostname does not match site URL without subdomain.
return!hostName.toLowerCase().includes(themeData.baseDomain.toLowerCase());}return false;});this.indicatorIcon='<i class="ion-android-open" aria-hidden="true"></i>';this.ariaLabelNewTab=themeData.themeStrings.common.opens_in_new_window;this.ariaLabelExternal=themeData.themeStrings.common.opens_external_link;}/**
     * All common events
     * @return {void}
     */},{key:'events',value:function events(){var _this=this;// Add the outline nullifying style to the
// container in the document head when using the mouse.
document.body.addEventListener('mousedown',function(e){_this.nullifyOutline();document.body.classList.add('js-ui-is-mouse');document.body.classList.add('js-ui-not-touch');document.body.classList.remove('js-ui-is-touch');document.body.classList.remove('js-ui-is-keyboard');});// Add the outline nullifying style to the
// container in the document head on touchevents.
document.body.addEventListener('touchstart',function(e){_this.nullifyOutline();document.body.classList.add('js-ui-is-touch');document.body.classList.remove('js-ui-not-touch');document.body.classList.remove('js-ui-is-mouse');document.body.classList.remove('js-ui-is-keyboard');});// Remove the outline nullifying style from the
// container in the document head when using the keyboard.
document.body.addEventListener('keydown',function(e){if(_this.focusStyleContainer){_this.focusStyleContainer.innerHTML='';}document.body.classList.add('js-ui-is-keyboard');document.body.classList.add('js-ui-not-touch');document.body.classList.remove('js-ui-is-mouse');document.body.classList.remove('js-ui-is-touch');});// Scroll to element on page. Will act as normal link if no element with the given ID (href of link) exists.
this.$scrollToLink.click(function(e){var trigger=this;// Get ID of element to scroll to
var targetId=$(e.currentTarget).attr('href');var $targetElement=$(targetId);// Return early if no element with given ID exists.
if(!$targetElement.length){return;}e.preventDefault();// Scroll to element.
var newPosition=$targetElement.offset();$('html, body').stop().animate({scrollTop:newPosition.top},500,function(){// Trigger a change to make sure the url is updated and focus changes properly.
// @link https://codepen.io/ppscvalentin/pen/JNNBzQ
window.location.href=trigger.href;});});// If the focused element is too low on the screen, scroll down enough to show it
// accounting the mobile menu which is attached to the bottom of the screen
document.addEventListener('focusin',function(e){// Get the currently active/focused element and its distance from the bottom of the viewport
var rect=document.activeElement.getBoundingClientRect();var spaceBelow=window.innerHeight-rect.bottom;// If the element's bottom is less than 50px from the viewport bottom, scroll down
if(spaceBelow<50){window.scrollBy(0,rect.height+100);}});// Handle outgoing links labeling
this.labelOutgoingLinks();}/**
     * Trigger a click event for a specific element.
     *
     * @param {object} e  The click event.
     * @param {object} el The captured event target element.
     * @return {void}
     * @memberof Menu
     */},{key:'triggerClick',value:function triggerClick(e,el){// Get selector for element tot click.
var selector=el.getAttribute('data-selector');if(selector){$(selector).first().trigger('click');}}/**
     * Add nullifying outline CSS rules to focusStyleContainer.
     */},{key:'nullifyOutline',value:function nullifyOutline(){if(this.focusStyleContainer){this.focusStyleContainer.innerHTML='*:focus{outline:none!important;}';}}/**
     * Fallback for object-fit (needed for IE browsers that are older than Edge 16).
     * @link https://medium.com/@primozcigler/neat-trick-for-css-object-fit-fallback-on-edge-and-other-browsers-afbc53bbb2c3
     * @return {void}
     */},{key:'objecfitFallback',value:function objecfitFallback(){if(!Modernizr.objectfit){// Get all object fit containers
var containers=Common.$('.js-object-fit-container');// Loop containers nodelist with Internet Explorer compatible way to use Array.prototype.forEach for iteration.
Array.prototype.forEach.call(containers,function(container){// Get object fit image element
var img=Common.$1('.js-object-fit-img',container);if(img){// Get object fit image url
var imgUrl=img.getAttribute('src');// Add class to container
container.classList.add('js-object-fit-fallback');// Add image as bg to container
container.style.backgroundImage='url('+imgUrl+')';}});}}/**
     * Add localized aria-label with the link text and "opens in new window" for links
     * opening in new tab, and "external link" for outgoing links.
     */},{key:'labelOutgoingLinks',value:function labelOutgoingLinks(){var _this2=this;// Add label and icon to links opening in new tab
this.linksInNewTab.forEach(function(link){link.setAttribute('aria-label',link.textContent+' ('+_this2.ariaLabelNewTab+')');// eslint-disable-line no-undef
link.innerHTML+=_this2.indicatorIcon;});// Add label and icon to external links
this.externalLinks.forEach(function(link){var ariaLabel=link.getAttribute('aria-label');if(ariaLabel){// If link already has aria-label, only update it
link.setAttribute('aria-label',link.textContent+' ('+_this2.ariaLabelNewTab+', '+_this2.ariaLabelExternal+')');}else{// Otherwise set the aria-label and add the icon
link.setAttribute('aria-label',link.textContent+' ('+_this2.ariaLabelExternal+')');link.innerHTML+=_this2.indicatorIcon;}});}/**
     * Run when the document is ready.
     */},{key:'docReady',value:function docReady(){this.cache();this.objecfitFallback();this.events();}/**
     * Check if all images have been loaded by the browser.
     *
     * @param {dom_object} context  A query context dom object. Used to find all images inside given object.
     * @param {function}   callback Optional callback function to run when all elements have been loaded.
     * @memberof SomeFeed
     */}],[{key:'imagesLoaded',value:function imagesLoaded(context,callback){// Get all image elements. Make sure given context is valid.
var images=void 0;try{images=context.querySelectorAll('img');}catch(error){console.error(error);return;}var totalImages=images.length;var nbrOfImagesLoaded=0;// Function that runs the callback.
var done=function done(args){if(typeof callback==='function'){callback(args);}};// Run callback and return early if no images found.
if(!totalImages){done(0);return;}// Function to check if all images have been loaded or not.
var check=function check(){nbrOfImagesLoaded++;if(nbrOfImagesLoaded===totalImages){done(nbrOfImagesLoaded);}};(0,_from2.default)(images).forEach(function(img){// Img.complete is needed img.onload will not run in IE 11.
// Because img.complete might return true (at least in FF) even before the data-srcset value has been copied
// to srcset, we have to check that the img width is wider than of our placeholder img (1px).
// If no support for IE11 is required, this block can probably be removed.
// https://stackoverflow.com/a/33025364
if(img.complete&&img.naturalWidth>1){check();return;}// This code will not run in IE 11 (Edge is fine) if image is in the cache.
img.onload=function(){check();};img.onerror=function(){check();};});}/**
     * Toggles the state of an elements aria-hidden attribute. If the element does not have an aria-hidden attribute,
     * one will be created and set to false.
     *
     * @param {object} elements The nodelist containing the elements
     * @return {void}
     */},{key:'toggleAriaHidden',value:function toggleAriaHidden(element){var ariaExpandedState=element.getAttribute('aria-hidden')==='false'?true:false;element.setAttribute('aria-hidden',ariaExpandedState);}/**
     * Checks if the element has a specific attribute and toggles its stage.
     *
     * @param {object} elements The nodelist containing the elements
     * @return {void}
     *//**
     * Checks if the element has a specific attribute and changes its value to the opposite.
     *
     * @static
     * @param {object} element   Element to toggle
     * @param {string} attribute Attribute to toggle
     * @memberof Common
     */},{key:'toggleBooleanAttribute',value:function toggleBooleanAttribute(element,attribute){var value=element.getAttribute(attribute);if(value&&(value==='false'||value==='true')){var newValue=value==='false'?true:false;element.setAttribute(attribute,newValue);}}/**
     * Removes classname from each element in a nodelist or array of elements.
     *
     * @param {object} elements  The nodelist containing the elements
     * @param {string} className The classlist to remove
     * @return {void}
     */},{key:'removeClassFromAll',value:function removeClassFromAll(elements,className){// Return early if missing required attributes.
if(!elements||!className){return;}(0,_from2.default)(elements).forEach(function(element){element.classList.remove(className);});}/**
     * Set attribute on each element in a nodelist or array of elements.
     *
     * @param {object} elements  The nodelist or array containing the elements
     * @param {string} attribute The attribut to change
     * @param {string} value     The value of the attribute
     * @return {void}
     */},{key:'setAttrOnAll',value:function setAttrOnAll(elements,attribute,value){// // Return early if missing required attributes.
if(!elements||!attribute||!value){return;}(0,_from2.default)(elements).forEach(function(element){element.setAttribute(attribute,value);});}/**
     * Get all the siblings of an element. Optionally specify a classname to only get the elements with said class.
     *
     * @param {object} element   The element whose sibilings to find.
     * @param {string} classname Optional classname that siblings must match.
     * @return {object}    Returns empty array if no matches are found; otherwise, it returns all matching elements.
     */},{key:'siblings',value:function siblings(element,classname){// Return empty arry if missing required attributes
if(!element){return[];}return Array.prototype.filter.call(element.parentNode.children,function(child){if(classname){if(!child.classList.contains(classname)){return false;}}return child!==element;});}/**
     * Select a list of matching child elements from an array of elements.
     *
     * @param  {object} elements A nodelist. Use each item in nodelist as context when finding the children.
     * @param  {string} selector The query selector string.
     * @return {object]}   Returns empty array if no matches are found; otherwise, it returns all matching elements.
     */},{key:'childrenFromEach',value:function childrenFromEach(elements,selector){// Return empty array if missing required attributes or elements empty
if(!elements||!selector||!elements.length>0){return[];}var arrayOfNodes=Array.prototype.map.call(elements,function(element){// Get all matching elements.
var matchingChildren=element.querySelectorAll(selector);// Convert nodelist to array.
return[].concat((0,_toConsumableArray3.default)(matchingChildren));});// Flatten the array
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/Reduce?v=a
var flattened=arrayOfNodes.reduce(function(a,b){return[].concat((0,_toConsumableArray3.default)(a),(0,_toConsumableArray3.default)(b));});return flattened;}/**
     * Offers safe way to stop a JS event.
     *
     * Example usage:
     * Theme.Common.stop(e);
     *
     * @param e Event object.
     */},{key:'stop',value:function stop(e){e.preventDefault?e.preventDefault():e.returnValue=false;}/**
     * Select a list of matching elements, context is optional.
     *
     * @param  {string} selector The query selector string.
     * @param  {object} context  A query context object.
     * @return {object}          Returns empty nodelist if no matches are found; otherwise, it returns a nodelist of matching elements.
     */},{key:'$',value:function $(selector,context){return(context||document).querySelectorAll(selector);}/**
     * Select the first match only, context is optional.
     *
     * @param  {string} selector The query selector string.
     * @param  {object} context  A query context object.
     * @return {object|null}     Returns null if no matches are found; otherwise, it returns the first matching element.
     */},{key:'$1',value:function $1(selector,context){return(context||document).querySelector(selector);}}]);return Common;}();// Export the class reference.
module.exports=Common;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _from = __webpack_require__(38);

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return (0, _from2.default)(arr);
  }
};

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(jQuery) {var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(3);var _createClass3=_interopRequireDefault(_createClass2);var _bodyScrollLock=__webpack_require__(88);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/**
 * Menu controller.
 *
 * This class controls the site menu and search functions.
 */// Use jQuery as $ within this file scope.
var $=jQuery;/**
 * Class Menu
 */var Menu=function(){/**
     * Class constructor is for binding class properties.
     */function Menu(){(0,_classCallCheck3.default)(this,Menu);// Store the status of the mobile overlay.
this.mobileOverlayOpen=false;}/**
     * Cache dom elements for use in the class's methods
     */(0,_createClass3.default)(Menu,[{key:'cache',value:function cache(){// Stores info is a desktop sub-menu is currently opened or not.
this.$desktopSubMenuIsOpen=false;// The container for the main desktop menu. Needed when checking the offset.
this.desktopNavContainer=document.getElementById('main-nav');// The mobile overlay toggle button.
this.hamburger=document.getElementById('js-mobile-toggle-btn');// The mobile full screen overlay that contains the mobile menu.
this.mobileOverlay=document.getElementById('js-mobile-overlay');// Get first and last focusable elements of the mobile menu..
if(this.mobileOverlay){var focusableElements=this.mobileOverlay.querySelectorAll('a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), [tabindex="0"]');if(focusableElements.length){var focusableElementsArr=Array.prototype.slice.call(focusableElements);this.firstMobileMenuLink=focusableElementsArr[0];this.lastMobileMenuLink=focusableElementsArr[focusableElementsArr.length-1];}}// The toggler button for the desktop navigation's search form container.
this.searchFormToggler=document.getElementById('header-search-toggle');// The container for the desktop navigation's search form.
this.searchFormContainer=document.getElementById('header-search');// The text input area inside the searchFormContainer
this.searchFormDesktopInput=document.getElementById('header-search__form__input');// Each top level menu item that has children.
this.menuParents=Theme.Common.$('.js-main-menu-nav .menu-item-has-children');// Each submenu inside the top level menu items that have children.
if(this.menuParents.length){this.menuSubMenus=Theme.Common.childrenFromEach(this.menuParents,'.js-sub-menu');this.subMenuToggleButtons=Theme.Common.childrenFromEach(this.menuParents,'.main-nav__submenu-toggle');}}/**
     * All common events
     * @return {void}
     */},{key:'events',value:function events(){var _this=this;document.addEventListener('keydown',function(evt){return _this.keyDownHandler(evt);});// Check if user has clicked outside an open menu
document.addEventListener('click',function(e){return _this.checkOutsideMenuClick(e);});}/**
     * Handle keydown events.
     *
     * @param {object} evt The key push event.
     * @return {void}
     */},{key:'keyDownHandler',value:function keyDownHandler(evt){// Return early if no mobile overlay exists.
if(!this.mobileOverlay){return;}// Return early if mobile overlay not open.
if(!this.mobileOverlay.classList.contains('js-open')){return;}evt=evt||window.event;var KEY_TAB=9;var KEY_ESC=27;switch(evt.keyCode){case KEY_TAB:// Return early if no hamburgers found.
if(!this.hamburger){return;}this.handleTabKeyEvent(evt);break;case KEY_ESC:this.toggleMobileOverlay();break;default:break;}// end switch
}/**
     * Handle tab key pushes inside modal.
     *
     * @param {object} evt The key push event.
     * @return {void}
     */},{key:'handleTabKeyEvent',value:function handleTabKeyEvent(evt){if(!this.firstMobileMenuLink||!this.hamburger){return;}// If shift + tab pushed.
if(evt.shiftKey){// Focus on hamburger element if focus was on the first element.
if(document.activeElement===this.firstMobileMenuLink){evt.preventDefault();this.hamburger.focus();return;}// Focus on last element if focus was on the hamburger element.
if(document.activeElement===this.hamburger){evt.preventDefault();this.lastMobileMenuLink.focus();return;}}else{// Focus on hamburger element if focus was on the last element.
if(document.activeElement===this.lastMobileMenuLink){evt.preventDefault();this.hamburger.focus();return;}// Focus on first element if focus was on the hamburger element.
if(document.activeElement===this.hamburger){evt.preventDefault();this.firstMobileMenuLink.focus();return;}}}/**
     * Toggles the search form container open and closed when the
     * magnifying class icon is clicked.
     * @return {void}
     */},{key:'toggleSearchForm',value:function toggleSearchForm(){var _this2=this;// Return early if missing required objects.
if(!this.searchFormContainer||!this.searchFormToggler){return;}// When search is opened, reset parent list items and
// sub menus back to their default, closed states. Set the
// aria-hidden state back to true when the menus are closed.
this.closeAllNavMenus();// Toggle the search form container's active state.
this.searchFormContainer.classList.toggle('js-active');// Get the toggler's aria-expanded current state and set a new opposite state to it.
// Also set the opened container's aria-hidden state to the new value's opposite.
var ariaExpandedState=this.searchFormToggler.getAttribute('aria-expanded')==='false'?true:false;this.searchFormToggler.setAttribute('aria-expanded',ariaExpandedState);this.searchFormContainer.setAttribute('aria-hidden',!ariaExpandedState);// Set focus to search input if search was opened with mouse. The body classlist is maybe not the most optimal
// way of checking the ui-type but will have to do for now.
if(document.body.classList.contains('js-ui-is-mouse')&&ariaExpandedState&&this.searchFormDesktopInput){// Set a small delay to the focusing of the form input, because of the CSS transition.
setTimeout(function(){_this2.searchFormDesktopInput.focus();},500);}}/**
     * Toggles the mobile menu overlay open and closed
     * @return {void}
     */},{key:'toggleMobileOverlay',value:function toggleMobileOverlay(){// Return early if missing required elements.
if(!this.hamburger||!this.mobileOverlay){return;}// Get the toggler's aria-expanded current state and set a new opposite state to it.
// Also set the opened container's aria-hidden state to the new value's opposite.
var ariaExpandedState=this.hamburger.getAttribute('aria-expanded')==='false'?true:false;this.hamburger.setAttribute('aria-expanded',ariaExpandedState);this.mobileOverlay.setAttribute('aria-hidden',!ariaExpandedState);// Toggle the overlay's and the hamburger's active states.
this.mobileOverlay.classList.toggle('js-open');this.hamburger.classList.toggle('is-active');// Toggle the class on site body that prevents background-scrolling.
document.body.classList.toggle('mobile-overlay-is-open');// Return early if hamburger closed.
if(!this.mobileOverlay.classList.contains('js-open')){// Remove styles and events that prevented the body from scrolling when the overlay was open.
(0,_bodyScrollLock.enableBodyScroll)(this.mobileOverlay);this.mobileOverlayOpen=false;this.hamburger.focus();return;}// Ads styles and events that prevents the body from scrolling when the overlay is open.
(0,_bodyScrollLock.disableBodyScroll)(this.mobileOverlay);this.mobileOverlayOpen=true;}/**
     * Toggles the sub menus open and closed.
     *
     * @param {object} e  The click event.
     * @param {object} el The captured event target element.
     * @return {void}
     * @memberof Menu
     */},{key:'toggleSubMenu',value:function toggleSubMenu(e,el){// The clicked element
var clickedElement=el;// Get the parent element of the clicked element.
var clickedParent=clickedElement.parentNode;if(!clickedParent.classList.contains('js-menu-item')){clickedParent=clickedParent.parentNode;}// Get the submenu inside the parent.
var subMenu=Theme.Common.$1('.js-sub-menu',clickedParent);// Get the siblings of the clicked menu
var siblingParents=Theme.Common.siblings(clickedParent,'menu-item-has-children');// Get the submenus of the siblings of the clicked menu
var siblingSubMenus=Theme.Common.childrenFromEach(siblingParents,'.js-sub-menu');// Get all the sub-parents in the siblings of the clicked menu.
var subParentsInSiblings=Theme.Common.childrenFromEach(siblingParents,'.menu-item-has-children');Theme.Common.toggleBooleanAttribute(clickedElement,'aria-expanded');// Toggle the clicked parent's active state and its sub menu's active state.
clickedParent.classList.toggle('js-active');if(subMenu){this.checkSubMenuOverflow(subMenu,clickedParent);subMenu.classList.toggle('js-active');this.maybeCloseChildSubMenus(subMenu,clickedParent);// Toggle the clicked parent's sub menu's aria-hidden state.
Theme.Common.toggleAriaHidden(subMenu);}// Remove the sibling parents' active states and their sub menus' active states.
// Set the aria-hidden state to true when the sub menus are closed.
Theme.Common.removeClassFromAll(siblingParents,'js-active');Theme.Common.removeClassFromAll(siblingSubMenus,'js-active');Theme.Common.removeClassFromAll(subParentsInSiblings,'js-active');Theme.Common.setAttrOnAll(siblingSubMenus,'aria-hidden',true);}/**
     * If submenu is a second level menu that is about to open, check if it will overlflow.
     * @param {object} subMenu The submenu to be checked.
     * @param {object} clickedParent The parent element of the submenu
     */},{key:'checkSubMenuOverflow',value:function checkSubMenuOverflow(subMenu,clickedParent){// Check that we are working with a second level (desktop) menu about to be opened.
if(subMenu.classList.contains('js-check-submenu-overflow--depth-2')&&!subMenu.classList.contains('js-active')&&!this.mobileOverlayOpen&&this.desktopNavContainer){// Store info that a submenu is open.
this.$desktopSubMenuIsOpen=true;// Get the offset of the parent item.
var parentOffset=clickedParent.getBoundingClientRect().left+window.scrollX;// Check if the submenu width combined with the parentOffset is larger than the container width.
var overflows=this.desktopNavContainer.offsetWidth<parentOffset+subMenu.offsetWidth;// Add or remove class to submenu depending on if it will fit in container.
if(overflows){subMenu.classList.remove('main-nav__sub-menu--depth-2--not-edge');subMenu.classList.add('main-nav__sub-menu--depth-2--at-edge');}else{subMenu.classList.remove('main-nav__sub-menu--depth-2--at-edge');subMenu.classList.add('main-nav__sub-menu--depth-2--not-edge');}}}/**
     * Closes all child sub-menu parents and child sub-menus if submenu is a second level menu that was closed.
     * @param {object} subMenu The submenu to be checked.
     * @param {object} clickedParent The parent element of the submenu
     */},{key:'maybeCloseChildSubMenus',value:function maybeCloseChildSubMenus(subMenu,clickedParent){// Check that we are working with a second level menu that was closed.
if(subMenu.classList.contains('main-nav__sub-menu--depth-2')&&!subMenu.classList.contains('js-active')){// Store info that all menus are closed.
this.$desktopSubMenuIsOpen=false;// Get all open child sub-menu parents.
var childSubParents=Theme.Common.$('.menu-item-has-children.js-active',clickedParent);// Get all open child sub-menus
var childSubMenus=Theme.Common.$('.js-sub-menu.js-active',clickedParent);// Get all open child sub-menu toggle-buttons.
var childSubMenuToggleButtons=Theme.Common.$('.main-nav__submenu-toggle[aria-expanded=true]',subMenu);Theme.Common.removeClassFromAll(childSubParents,'js-active');Theme.Common.removeClassFromAll(childSubMenus,'js-active');Theme.Common.setAttrOnAll(childSubMenus,'aria-hidden',true);Theme.Common.setAttrOnAll(childSubMenuToggleButtons,'aria-expanded','false');}}/**
     * Resets all open main menus
     */},{key:'closeAllNavMenus',value:function closeAllNavMenus(){if(this.menuParents&&this.menuSubMenus){Theme.Common.removeClassFromAll(this.menuParents,'js-active');Theme.Common.removeClassFromAll(this.menuSubMenus,'js-active');Theme.Common.setAttrOnAll(this.menuSubMenus,'aria-hidden',true);Theme.Common.setAttrOnAll(this.subMenuToggleButtons,'aria-expanded','false');// Store info that all menus are closed.
this.$desktopSubMenuIsOpen=false;}}/**
     * Checks if clicked outside of opened menu.
     * @link https://stackoverflow.com/a/3028037
     *
     * @param {object} e Event object.
     * @return {void}
     */},{key:'checkOutsideMenuClick',value:function checkOutsideMenuClick(e){if(!this.$desktopSubMenuIsOpen){return;}// Close modal if the click event was not inside the modal__content-wrap os modal__btn items.
if(!$(e.target).closest('#main-nav').length){this.closeAllNavMenus();}}/**
     * Hide and show mobile navigation on scroll
     *
     * @return {void}
     */},{key:'mobileNavScroll',value:function mobileNavScroll(){var prevScrollpos=window.pageYOffset;document.addEventListener('scroll',function(){var currentScrollPos=window.pageYOffset;var navigation=$('#mobile-nav-and-search__toggle');// If user has scrolled over initial mobile nav height
if(currentScrollPos>60){// Hide or show mobile nav when scrolling
if(prevScrollpos>currentScrollPos){navigation.removeClass('navigation-hide');}else{navigation.addClass('navigation-hide');}prevScrollpos=currentScrollPos;}});}/**
     * Run when the document is ready.
     */},{key:'docReady',value:function docReady(){this.mobileNavScroll();this.cache();this.events();}}]);return Menu;}();// Export the class reference.
module.exports=Menu;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!function(e,t){if(true)!(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (t),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));else if("undefined"!=typeof exports)t(exports);else{var o={};t(o),e.bodyScrollLock=o}}(this,function(exports){"use strict";function i(e){if(Array.isArray(e)){for(var t=0,o=Array(e.length);t<e.length;t++)o[t]=e[t];return o}return Array.from(e)}Object.defineProperty(exports,"__esModule",{value:!0});var l=!1;if("undefined"!=typeof window){var e={get passive(){l=!0}};window.addEventListener("testPassive",null,e),window.removeEventListener("testPassive",null,e)}function d(t){return u.some(function(e){return!(!e.options.allowTouchMove||!e.options.allowTouchMove(t))})}function c(e){var t=e||window.event;return!!d(t.target)||(1<t.touches.length||(t.preventDefault&&t.preventDefault(),!1))}function o(){setTimeout(function(){void 0!==m&&(document.body.style.paddingRight=m,m=void 0),void 0!==f&&(document.body.style.overflow=f,f=void 0)})}var a="undefined"!=typeof window&&window.navigator&&window.navigator.platform&&(/iP(ad|hone|od)/.test(window.navigator.platform)||"MacIntel"===window.navigator.platform&&1<window.navigator.maxTouchPoints),u=[],s=!1,v=-1,f=void 0,m=void 0;exports.disableBodyScroll=function(r,e){if(a){if(!r)return void console.error("disableBodyScroll unsuccessful - targetElement must be provided when calling disableBodyScroll on IOS devices.");if(r&&!u.some(function(e){return e.targetElement===r})){var t={targetElement:r,options:e||{}};u=[].concat(i(u),[t]),r.ontouchstart=function(e){1===e.targetTouches.length&&(v=e.targetTouches[0].clientY)},r.ontouchmove=function(e){var t,o,n,i;1===e.targetTouches.length&&(o=r,i=(t=e).targetTouches[0].clientY-v,d(t.target)||(o&&0===o.scrollTop&&0<i||(n=o)&&n.scrollHeight-n.scrollTop<=n.clientHeight&&i<0?c(t):t.stopPropagation()))},s||(document.addEventListener("touchmove",c,l?{passive:!1}:void 0),s=!0)}}else{n=e,setTimeout(function(){if(void 0===m){var e=!!n&&!0===n.reserveScrollBarGap,t=window.innerWidth-document.documentElement.clientWidth;e&&0<t&&(m=document.body.style.paddingRight,document.body.style.paddingRight=t+"px")}void 0===f&&(f=document.body.style.overflow,document.body.style.overflow="hidden")});var o={targetElement:r,options:e||{}};u=[].concat(i(u),[o])}var n},exports.clearAllBodyScrollLocks=function(){a?(u.forEach(function(e){e.targetElement.ontouchstart=null,e.targetElement.ontouchmove=null}),s&&(document.removeEventListener("touchmove",c,l?{passive:!1}:void 0),s=!1),u=[],v=-1):(o(),u=[])},exports.enableBodyScroll=function(t){if(a){if(!t)return void console.error("enableBodyScroll unsuccessful - targetElement must be provided when calling enableBodyScroll on IOS devices.");t.ontouchstart=null,t.ontouchmove=null,u=u.filter(function(e){return e.targetElement!==t}),s&&0===u.length&&(document.removeEventListener("touchmove",c,l?{passive:!1}:void 0),s=!1)}else(u=u.filter(function(e){return e.targetElement!==t})).length||o()}});


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(3);var _createClass3=_interopRequireDefault(_createClass2);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/**
 * LoadMore controller.
 *
 * This class controls the load more functionalilty.
 */var _wp$i18n=wp.i18n,__=_wp$i18n.__,sprintf=_wp$i18n.sprintf;/**
 * Class LoadMore
 */var LoadMore=function(){/**
     * Class constructor is for binding class properties.
     */function LoadMore(){(0,_classCallCheck3.default)(this,LoadMore);// Current pagination number in.
this.page=0;// Max number of pages available.
this.maxPage=0;}/**
     * Cache dom elements for use in the class's methods
     */(0,_createClass3.default)(LoadMore,[{key:'cache',value:function cache(){}/**
     * All common events
     * @return {void}
     */},{key:'events',value:function events(){}/**
     * Set up required class variables and call getPosts.
     *
     * @param {obj} e       Load more click event.
     * @param {obj} element Captured load more element.
     */},{key:'loadMore',value:function loadMore(e,element){this.initLoadMore(element);// Increment this.page and call getPosts.
this.page++;this.getPosts();}/**
     * Set up required class variables.
     *
     * @param {*} el Load more click target.
     */},{key:'initLoadMore',value:function initLoadMore(el){if(!this.page){this.loadMoreBtn=el;var dataPage=this.loadMoreBtn.getAttribute('data-page');this.page=dataPage?parseInt(dataPage):1;var dataMaxPage=this.loadMoreBtn.getAttribute('data-maxpage');this.maxPage=dataMaxPage?parseInt(dataMaxPage):1;// Get info about what DustPress model should be used when retrieving data.
this.dpModel=this.loadMoreBtn.getAttribute('data-model');// Get info about what DustPress partial should be used when retrieving data.
this.dpPartial=this.loadMoreBtn.getAttribute('data-partial');// Define the element where the loaded posts will we appended to.
var targetElementId=this.loadMoreBtn.getAttribute('data-target');if(targetElementId){this.targetElement=document.getElementById(targetElementId);}// Get the slug that will be used for the pagination url.
var pageSlug=this.loadMoreBtn.getAttribute('data-pageslug');this.pageSlug=pageSlug?pageSlug:'page';// Define RegExp that will be used when checking if current pathname contains the pageslug.
this.pageSlugPattern=new RegExp(this.pageSlug);// Define a RegExp that will be used when replacing the current path while manipulating history.
// Matches when a string ends with the pageslug followed by a slash and digits (and possible a slash).
// Example matches when pageslug is page: foo/page/2 and foo/bar/page/14/
this.pageSlugReplacePattern=new RegExp(this.pageSlug+'\/(\\d+)\/?');// Check if a queryString has been defined. If so, it will be used to manipulate the history instead of the
// page-slug.
this.queryString=this.loadMoreBtn.getAttribute('data-querystring');}}/**
     * Use DustPress JS to load more posts.
     */},{key:'getPosts',value:function getPosts(){var _this=this;// Return early if model or partial missing
if(!this.dpModel||!this.dpPartial){return;}// Change the loading state.
this.toggleLoader(true);dp(this.dpModel,{partial:this.dpPartial,tidy:true,data:true,args:{page:this.page}}).then(function(data){_this.successHandler(data);}).catch(function(error){_this.errorHandler(error);});}/**
     * Manipulates browser history, appends data to DOM and toggles loading state.
     *
     * @param {mixed} data Data usually returned from a DustPress JS ajax request.
     */},{key:'successHandler',value:function successHandler(data){this.manipulateHistory();// Append search results to searchResultsContainer. Also checking data variable. It might be false if
// trying to get data from a DustPress model that does not exist.
if(this.targetElement&&data.success){// Get the last article before appending and the number of articles before loading in the new result set
var currentLastChild=this.targetElement.lastElementChild;var articlesBeforeLoad=this.targetElement.getElementsByTagName('article').length;// Append the search results
this.targetElement.insertAdjacentHTML('beforeend',data.success);// The number of articles loaded
var articlesLoaded=this.targetElement.getElementsByTagName('article').length-articlesBeforeLoad;// Inform screen readers of the change
/* translators: number of loaded articles */wp.a11y.speak(sprintf(__('%d new articles loaded.','the-dustpress-theme'),articlesLoaded),'polite');// Change the focus to the first appended element's title link
var nextSiblingLinks=currentLastChild.nextElementSibling.getElementsByClassName('js-load-more-focus');if(nextSiblingLinks.length){nextSiblingLinks[0].focus();}}// Bind new lazy-load images.
var lazyImages=Theme.Common.$('.js-lazyload-img',this.targetElement);this.viewportVisibility.scrollTrigger.bind(lazyImages);// Make ScrollTrigger think an scroll event happened.
this.viewportVisibility.scrollTrigger.scrollDidChange();// Change loading state. Call with loading state as false, so that the button gets removed if needed.
this.toggleLoader(false);}/**
     * Handles failed DustPress JS request.
     *
     * @param {mixed} error Error returned by failed DustPress JS request.
     */},{key:'errorHandler',value:function errorHandler(error){this.toggleLoader(false);console.log(error);}/**
     * Manipulate the window history by adding or changing the page number in the url.
     */},{key:'manipulateHistory',value:function manipulateHistory(){// Return early if history manipulation not supported.
if(!window.history){return;}// Manipulate querys string if it is defined.
if(this.queryString){var url=this.updateQueryStringParameter(window.location.href,this.queryString,this.page);window.history.replaceState({},'',url);return;}// Check if history is supported in browser and required variables are set.
if(this.pageSlug&&this.pageSlugPattern&&this.pageSlugReplacePattern){var path=location.pathname;// Check if the url contains a page and replace the current location with the new state.
// Remove pagination from current path.
if(this.pageSlugPattern.test(location.pathname)){path=location.pathname.replace(this.pageSlugReplacePattern,'');}// Remove possible slash from end of path
path=path.replace(/\/$/,'');// Add pagination to path.
path=path+'/'+this.pageSlug+'/'+this.page+'/';// Push the newly generated url to history.
var _url=window.location.protocol+'//'+location.host+path;window.history.replaceState({},'',_url);}}/**
     * Add or update a query string parameter
     * @link https://stackoverflow.com/a/6021027
     *
     * @param {string} uri The entire url of the page.
     * @param {string} key The query string key.
     * @param {string} value The query string value.
     * @return {string} The url with the updated query string
     */},{key:'updateQueryStringParameter',value:function updateQueryStringParameter(uri,key,value){var re=new RegExp('([?&])'+key+'=.*?(&|$)','i');var separator=uri.indexOf('?')!==-1?'&':'?';if(uri.match(re)){return uri.replace(re,'$1'+key+'='+value+'$2');}else{return uri+separator+key+'='+value;}}/**
     * Changes the state of the loader.
     *
     * @param {bool} isLoading The current loading state of the app. If false, checks if the button should be removed.
     */},{key:'toggleLoader',value:function toggleLoader(){var isLoading=arguments.length>0&&arguments[0]!==undefined?arguments[0]:true;if(this.loadMoreBtn){// Toggle button loading state.
this.loadMoreBtn.classList.toggle('is-loading');// Hide load more button if there is nothing more to load.
if(!isLoading&&this.page>=this.maxPage){var btnParent=this.loadMoreBtn.parentNode;if(btnParent.classList.contains('js-remove-when-empty')){btnParent.parentNode.removeChild(btnParent);}else{btnParent.removeChild(this.loadMoreBtn);}}}// Change target aria-busy status depending on loading state.
// @link http://csskarma.com/blog/using-aria-live-regions/
if(this.targetElement){if(isLoading){this.targetElement.setAttribute('aria-busy','true');}else{this.targetElement.setAttribute('aria-busy','false');}}}/**
     * Run when the document is ready.
     */},{key:'docReady',value:function docReady(){this.viewportVisibility=Theme.getController('ViewportVisibility');this.cache();this.events();}}]);return LoadMore;}();// Export the class reference.
module.exports=LoadMore;

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(jQuery) {var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(3);var _createClass3=_interopRequireDefault(_createClass2);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/**
 * Accordion JS controller.
 */// Use jQuery as $ within this file scope.
var $=jQuery;/**
 * Class Accordion
 */var Accordion=function(){/**
     * Class constructor is for binding class properties.
     */function Accordion(){(0,_classCallCheck3.default)(this,Accordion);}/**
     * This functions is run after all script classes have been instantiated.
     * Use this if you need to access some other script instances before the document ready event.
     */(0,_createClass3.default)(Accordion,[{key:'init',value:function init(){}/**
     * Cache dom elements for use in the class's methods
     */},{key:'cache',value:function cache(){this.accordionHeadings=$('.js-accordion__item-heading');}/**
     * All common events
     * @return {void}
     */},{key:'events',value:function events(){var _this=this;// Every heading in the accordion needs to be clickable and
// when clicked, open the hidden content under it.
this.accordionHeadings.each(function(index,accordionHeading){$(accordionHeading).on('click',function(e){_this.accordionClickHandle(e,accordionHeading);});});}/**
     * Handles toggling of accordion items.
     *
     * @param {event object} e
     * @param {dom node} accordionHeading
     */},{key:'accordionClickHandle',value:function accordionClickHandle(e,accordionHeading){var _this2=this;Theme.Common.stop(e);var $accordionHeading=$(accordionHeading);var $accordion=$accordionHeading.parent();this.toggleAccordionItem($accordion);$accordion.siblings('.accordion__item--open').each(function(index,element){_this2.toggleAccordionItem($(element));});}/**
     * This handles the toggling of the accordion elements' visibility and aria classes.
     *
     * @param {obj} accordionHeading jQuery object.
     */},{key:'toggleAccordionItem',value:function toggleAccordionItem($accordion){var $accordionHeading=$accordion.find('.js-accordion__item-heading');var ariaExpandedState=$accordionHeading.attr('aria-expanded')==='false'?true:false;var $accordionContent=$accordion.find('.js-accordion__item-content');var ariaHiddenState=$accordionContent.attr('aria-hidden')==='false'?true:false;$accordion.toggleClass('accordion__item--open');$accordion.toggleClass('js-open');$accordionHeading.attr('aria-expanded',ariaExpandedState);// Set or remove the aria-hidden attribute.
// Don't use value "false" because of its lacking support on different devices.
if(ariaHiddenState){$accordionContent.attr('aria-hidden',true);}else{$accordionContent.removeAttr('aria-hidden');}}/**
     * Run when the document is ready.
     */},{key:'docReady',value:function docReady(){this.cache();this.events();}}]);return Accordion;}();// Export the class reference.
module.exports=Accordion;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(jQuery) {var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(3);var _createClass3=_interopRequireDefault(_createClass2);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/**
 * Filter controller.
 *
 * This class controls filter areas
 */// Use jQuery as $ within this file scope.
var $=jQuery;/**
 * Class Filter
 */var Filter=function(){/**
     * Class constructor is for binding class properties.
     */function Filter(){(0,_classCallCheck3.default)(this,Filter);// Object to hold all filter areas.
this.filterAreasById={};}/** 
     * Cache dom elements for use in the class's methods
     */(0,_createClass3.default)(Filter,[{key:'cache',value:function cache(){var _this=this;this.$buttons=$('.js-filter-ctrl');// Save an object of all filter areas panes.
$('.js-filter-area').each(function(index,element){_this.registerFilterArea(element);});}/**
     * Register a new filter area.
     *
     * @param {*} element Dom element to register. 
     * @memberof Filter
     */},{key:'registerFilterArea',value:function registerFilterArea(element){// Every filter area must have an unique ID.
if(element.id){var filterAreaObj={'element':element,'keys':[]};this.filterAreasById[element.id]=filterAreaObj;}}/**
     * Handles filter control click event.
     * 
     * @param {event object} e The click event.
     * @param {dom node} button The clicked filter control element.
     */},{key:'filterClickHandle',value:function filterClickHandle(e,button){Theme.Common.stop(e);var filterAreaId=button.dataset.filterArea;var filterKey=button.dataset.filterKey.toString();if(filterAreaId&&filterKey){this.filter(filterAreaId,filterKey);}}/**
     * Updates the filter keys for filter-area with the given key. Then calls methods to update items and buttons.
     *
     * @param {string} filterAreaId ID of filter area to update.
     * @param {string} filterKey    Filter key that should be added or removed from the area.
     * @returns
     * @memberof Filter
     */},{key:'filter',value:function filter(filterAreaId,filterKey){// Return early if area with given key not found.
if(!this.filterAreasById[filterAreaId]){return;}var areaKeys=this.filterAreasById[filterAreaId].keys;// Remove the item from the array if it already existed in it. Otherwise add it to the array.
if(areaKeys.includes(filterKey)){this.filterAreasById[filterAreaId].keys=areaKeys.filter(function(item){return item!==filterKey;});}else{this.filterAreasById[filterAreaId].keys.push(filterKey);}// The filtering is primarily used for the some-feed. The some-feed should by default show all items. Because
// of that, we show all items if no filter is selected.
var makeAllItemsActive=this.filterAreasById[filterAreaId].keys.length<1;this.updateItemsStatus(filterAreaId,makeAllItemsActive);// Changing the button status here instead of earlier, when clicked. Enables us to have multiple buttons with
// the same filter key. Eg. before and after the filter area.
this.updateButtonsStatus(filterAreaId);// Create a custom event so that other classes can react when something is filtered.
var filterEvent=document.createEvent('CustomEvent');// Pass the keys and the id of the filter area as detail-data since it might be useful.
filterEvent.initCustomEvent('dptfilter',true,true,{filterAreaId:filterAreaId,areaKeys:areaKeys});// Dispatch the custom event.
this.filterAreasById[filterAreaId].element.dispatchEvent(filterEvent);}/**
     * Update each filter-item in filter area with given id.
     *
     * @param {string} filterAreaId         Id of filter area with the items to update. 
     * @param {boolean} [activateAll=false] Set to true to make all items active.
     * @memberof Filter
     */},{key:'updateItemsStatus',value:function updateItemsStatus(filterAreaId){var activateAll=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;var areaKeys=this.filterAreasById[filterAreaId].keys;$(this.filterAreasById[filterAreaId].element).find('.js-filter-item ').each(function(index,item){if(activateAll){item.classList.add('js-filter-item-active');item.classList.remove('js-filter-item-inactive');return;}var filterKey=item.dataset.filter;if(areaKeys.includes(filterKey)){item.classList.add('js-filter-item-active');item.classList.remove('js-filter-item-inactive');}else{item.classList.remove('js-filter-item-active');item.classList.add('js-filter-item-inactive');}});}/**
     * Update each filter-control for filter area with given id.
     *
     * @param {string} filterAreaId Id of filter area with the items to update. 
     * @memberof Filter
     */},{key:'updateButtonsStatus',value:function updateButtonsStatus(filterAreaId){var areaKeys=this.filterAreasById[filterAreaId].keys;this.$buttons.each(function(index,button){var filterArea=button.dataset.filterArea;var filterKey=button.dataset.filterKey.toString();// Return early if this is not a button that controls the current area.
if(filterArea!=filterAreaId){return;}if(areaKeys.includes(filterKey)){button.classList.add('js-filter-active');}else{button.classList.remove('js-filter-active');}});}/**
     * Run when the document is ready.
     * @return {void}
     */},{key:'docReady',value:function docReady(){this.cache();}}]);return Filter;}();// Export the class reference.
module.exports=Filter;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(3);var _createClass3=_interopRequireDefault(_createClass2);var _scrolltriggerClasses=__webpack_require__(93);var _scrolltriggerClasses2=_interopRequireDefault(_scrolltriggerClasses);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/**
 * Class LocationsControl
 */var ViewportVisibility=function(){/**
     * Class constructor is for binding class properties.
     */function ViewportVisibility(){(0,_classCallCheck3.default)(this,ViewportVisibility);}/**
     * This functions is run after all script classes have been instantiated.
     * Use this if you need to access some other script instances before the document ready event.
     */(0,_createClass3.default)(ViewportVisibility,[{key:'init',value:function init(){// Define customs functions that run when elements with them as a scrollTrigger callback come into view.
// https://github.com/terwanerik/ScrollTrigger/blob/master/README.md#callbacks
// 
// Unfortunately things like this do no work in ScrollTrigger: `data-scroll-showCallback="Theme.ViewportVisibility.showLazyImage()`.
// Probably because scrolltrigger would try to run them like this `this.scrollTrigger.callScope[Theme.ViewportVisibility.showLazyImage].apply( trigger.element, params )`
//
// Defining a custom callscope will not work either, since it is not available when scrollTrigger initializes. Custom callscope can't be defined as an option.
window.DPTLazyImageCb=function(){// `this` refers to the html element coming into the viewport
var el=this;Theme.ViewportVisibility.showLazyImage(el);};window.DPTSomeFeedShowCb=function(){// `this` refers to the html element coming into the viewport
var el=this;Theme.SomeFeed.DPTLazySomeFeed(el);};}/** 
     * Cache dom elements for use in the class's methods
     */},{key:'cache',value:function cache(){// Get all elements watched by ScrollTrigger. Alternatively the selector could be `js-lazyload-img` to only get
// lazy load images.
this.scrollTriggerElements=document.querySelectorAll('[data-scroll]');}/**
     * Set up ScrollTrigger.
     * @link https://github.com/terwanerik/ScrollTrigger 
     */},{key:'setUpScrollTrigger',value:function setUpScrollTrigger(){var _this=this;this.scrollTrigger=new _scrolltriggerClasses2.default({toggle:{visible:'js-st-visible',hidden:'js-st-invisible'}});// Manually run the ScrollTrigger update method once since in some cases ScrollTrigger misses something on
// the initial load. This is usually if there are elements with offset setting very high or low in the
// viewport. This should not be needed if he issue https://github.com/terwanerik/ScrollTrigger/issues/49 gets
// fixed.
this.scrollTrigger.scrollDidChange();// Just run one more check for the elements that ScrollTrigger might have missed. This should not be needed if 
// the issue https://github.com/terwanerik/ScrollTrigger/issues/49 gets fixed.
// Setting a timeout to make sure that the browser has been given enough time to scroll to the correct position
// in case the user has reloaded the page returned to it with back-functionality.
setTimeout(function(){_this.checkScrollTriggerElements();},1000);}/**
     * Checks if any of the scrollTrigger elements are currently in the viewport. If they are, change classes and run
     * callbacks. This is more or less the same code as in ScrollTrigger.js
     *
     * @memberof ViewportVisibility
     */},{key:'checkScrollTriggerElements',value:function checkScrollTriggerElements(){var _this2=this;Array.prototype.forEach.call(this.scrollTriggerElements,function(element){// Check if any part of the element is in the viewport.
if(_this2.isVisible(element)){// Get the scrollTrigger object of the element.
var trigger=_this2.scrollTrigger.triggerFor(element);// Run the class adding and removal functions. Copied from ScrollTriggrer.js
if(trigger){// Add class to element and run possible callback
trigger.addClass(trigger.visibleClass,function(){if(trigger.showCallback){_this2.functionCall(trigger,trigger.showCallback);}});trigger.removeClass(trigger.hiddenClass);// Remove the Trigger object for the given element if it is a "once" object. 
if(trigger.once){_this2.scrollTrigger.destroy(element);}}}});}/**
     * Check if any part of an element is in the viewport.
     * Note that this appears to have some unexpected behavior in IE and Edge if not scrolled to the top on docReady.
     * @param {object} el Element to check.
     */},{key:'isVisible',value:function isVisible(el){var _el$getBoundingClient=el.getBoundingClientRect(),top=_el$getBoundingClient.top,bottom=_el$getBoundingClient.bottom;var vHeight=window.innerHeight||document.documentElement.clientHeight;return(top>0||bottom>0)&&top<vHeight;}/**
     * Function needed by ScrollTrigger to run callback functions. Copied from ScrollTrigger.js
     * @param {object} trigger ScrollTrigger object.
     * @param {string} functionAsString Defined callback function..
     */},{key:'functionCall',value:function functionCall(trigger,functionAsString){var _this3=this;var params=functionAsString.split('(');var method=params[0];if(params.length>1){params=params[1].split(')')[0];// get the value between the parentheses
// check if there are multiple attributes
if(params.indexOf('\', \'')>-1){params=params.split('\', \'');}else if(params.indexOf('\',\'')>-1){params=params.split('\',\'');}else if(params.indexOf('", "')>-1){params=params.split('", "');}else if(params.indexOf('","')>-1){params=params.split('","');}else{// nope, just a single parameter
params=[params];}}else{params=[];}// remove all quotes from the parameters
params=params.map(function(param){return _this3.removeQuotes(param);});if(typeof this.scrollTrigger.callScope[method]=='function'){// function exists in the call scope so let's try to call it. Some methods don't like to have the HTMLElement
// passed as 'this', so retry without that if it fails.
try{this.scrollTrigger.callScope[method].apply(trigger.element,params);}catch(e){// alright let's try again
try{this.scrollTrigger.callScope[method].apply(null,params);}catch(e){// ah to bad.
}}}}/**
     * Removes quotes from a string, e.g. turns 'foo' or "foo" into foo. Copied from ScrollTrigger.js.
     * @param {string} str String to remove quotes from.
     */},{key:'removeQuotes',value:function removeQuotes(str){str=str+'';// force a string
if(str[0]=='"'){str=str.substr(1);}if(str[0]=='\''){str=str.substr(1);}if(str[str.length-1]=='"'){str=str.substr(0,str.length-1);}if(str[str.length-1]=='\''){str=str.substr(0,str.length-1);}return str;}/**
     * Reveal an lazyload image. Updates image srscet and classnames.
     * @param {object} el The image element to update.
     */},{key:'docReady',/**
     * Run when the document is ready.
     */value:function docReady(){this.cache();this.setUpScrollTrigger();}}],[{key:'showLazyImage',value:function showLazyImage(el){// Replace content of srcset with content of data-srcset.
var dataSrcSet=el.getAttribute('data-srcset');if(dataSrcSet&&el.classList.contains('js-lazyload-img')){el.setAttribute('srcset',dataSrcSet);// Update class. This tells possible other functions that the lazy-handling has been done.
el.classList.add('js-lazyload-img-loaded');el.classList.remove('js-lazyload-img');return;}}}]);return ViewportVisibility;}();// Export the class reference.
/**
 * ViewportVisibility JS controller.
 */// Use ScrollTrigger to detect when elements come into viewport.
module.exports=ViewportVisibility;

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* Written by Erik Terwan - MIT license - https://github.com/terwanerik */
!function(t,e){ true?!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (e),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):"object"==typeof module&&module.exports?module.exports=e():t.ScrollTrigger=e()}(this,function(){"use strict";return function(t,e,n){function i(){var t=h.bindElement.scrollTop?h.bindElement.scrollTop:document.documentElement.scrollTop,e=h.bindElement.scrollLeft?h.bindElement.scrollLeft:document.documentElement.scrollLeft;a.left==e&&a.top==t||h.scrollDidChange(),r.length>0||c.length>0?(u=!0,d(i)):u=!1}function l(t,e){var n=e.split("("),i=n[0];if(n.length>1?(n=n[1].split(")")[0],n=n.indexOf("', '")>-1?n.split("', '"):n.indexOf("','")>-1?n.split("','"):n.indexOf('", "')>-1?n.split('", "'):n.indexOf('","')>-1?n.split('","'):[n]):n=[],n=n.map(function(t){return s(t)}),"function"==typeof h.callScope[i])try{h.callScope[i].apply(t.element,n)}catch(l){try{h.callScope[i].apply(null,n)}catch(l){}}}function s(t){return t+="",'"'==t[0]&&(t=t.substr(1)),"'"==t[0]&&(t=t.substr(1)),'"'==t[t.length-1]&&(t=t.substr(0,t.length-1)),"'"==t[t.length-1]&&(t=t.substr(0,t.length-1)),t}var o=function(t,e){this.element=e,this.defaultOptions=t,this.showCallback=null,this.hideCallback=null,this.visibleClass="visible",this.hiddenClass="invisible",this.addWidth=!1,this.addHeight=!1,this.once=!1;var n=0,i=0;this.left=function(t){return function(){return t.element.getBoundingClientRect().left}}(this),this.top=function(t){return function(){return t.element.getBoundingClientRect().top}}(this),this.xOffset=function(t){return function(e){var i=n;return t.addWidth&&!e?i+=t.width():e&&!t.addWidth&&(i-=t.width()),i}}(this),this.yOffset=function(t){return function(e){var n=i;return t.addHeight&&!e?n+=t.height():e&&!t.addHeight&&(n-=t.height()),n}}(this),this.width=function(t){return function(){return t.element.offsetWidth}}(this),this.height=function(t){return function(){return t.element.offsetHeight}}(this),this.reset=function(t){return function(){t.removeClass(t.visibleClass),t.removeClass(t.hiddenClass)}}(this),this.addClass=function(t){var e=function(e,n){t.element.classList.contains(e)||(t.element.classList.add(e),"function"==typeof n&&n())},n=function(e,n){e=e.trim();var i=new RegExp("(?:^|\\s)"+e+"(?:(\\s\\w)|$)","ig"),l=t.element.className;i.test(l)||(t.element.className+=" "+e,"function"==typeof n&&n())};return t.element.classList?e:n}(this),this.removeClass=function(t){var e=function(e,n){t.element.classList.contains(e)&&(t.element.classList.remove(e),"function"==typeof n&&n())},n=function(e,n){e=e.trim();var i=new RegExp("(?:^|\\s)"+e+"(?:(\\s\\w)|$)","ig"),l=t.element.className;i.test(l)&&(t.element.className=l.replace(i,"$1").trim(),"function"==typeof n&&n())};return t.element.classList?e:n}(this),this.init=function(t){return function(){var e=t.defaultOptions,l=t.element.getAttribute("data-scroll");e&&(e.toggle&&e.toggle.visible&&(t.visibleClass=e.toggle.visible),e.toggle&&e.toggle.hidden&&(t.hiddenClass=e.toggle.hidden),e.showCallback&&(t.showCallback=e.showCallback),e.hideCallback&&(t.hideCallback=e.hideCallback),e.centerHorizontal===!0&&(n=t.element.offsetWidth/2),e.centerVertical===!0&&(i=t.element.offsetHeight/2),e.offset&&e.offset.x&&(n+=e.offset.x),e.offset&&e.offset.y&&(i+=e.offset.y),e.addWidth&&(t.addWidth=e.addWidth),e.addHeight&&(t.addHeight=e.addHeight),e.once&&(t.once=e.once));var s=l.indexOf("addWidth")>-1,o=l.indexOf("addHeight")>-1,r=l.indexOf("once")>-1;t.addWidth===!1&&s===!0&&(t.addWidth=s),t.addHeight===!1&&o===!0&&(t.addHeight=o),t.once===!1&&r===!0&&(t.once=r),t.showCallback=t.element.hasAttribute("data-scroll-showCallback")?t.element.getAttribute("data-scroll-showCallback"):t.showCallback,t.hideCallback=t.element.hasAttribute("data-scroll-hideCallback")?t.element.getAttribute("data-scroll-hideCallback"):t.hideCallback;var c=l.split("toggle(");if(c.length>1){var a=c[1].split(")")[0].split(",");String.prototype.trim||(String.prototype.trim=function(){return this.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,"")}),t.visibleClass=a[0].trim().replace(".",""),t.hiddenClass=a[1].trim().replace(".","")}l.indexOf("centerHorizontal")>-1&&(n=t.element.offsetWidth/2),l.indexOf("centerVertical")>-1&&(i=t.element.offsetHeight/2);var d=l.split("offset(");if(d.length>1){var u=d[1].split(")")[0].split(",");n+=parseInt(u[0].replace("px","")),i+=parseInt(u[1].replace("px",""))}return t}}(this)};this.scrollElement=window,this.bindElement=document.body,this.callScope=window;var r=[],c=[],a={left:-1,top:-1},d=window.requestAnimationFrame||window.webkitRequestAnimationFrame||window.mozRequestAnimationFrame||window.msRequestAnimationFrame||window.oRequestAnimationFrame||function(t){setTimeout(t,1e3/60)},u=!1,f=function(t){return function(e,n,i){return void 0!=n&&null!=n?t.bindElement=n:t.bindElement=document.body,void 0!=i&&null!=i?t.scrollElement=i:t.scrollElement=window,t.bind(t.bindElement.querySelectorAll("[data-scroll]")),t}}(this);this.bind=function(e){return function(n){n instanceof HTMLElement&&(n=[n]);var l=[].slice.call(n);return l=l.map(function(e){var n=new o(t,e);return n.init()}),r=r.concat(l),r.length>0&&0==u?(u=!0,i()):u=!1,e}}(this),this.triggerFor=function(){return function(t){var e=null;return r.each(function(n){n.element==t&&(e=n)}),e}}(this),this.destroy=function(t){return function(e){return r.each(function(t,n){t.element==e&&r.splice(n,1)}),t}}(this),this.destroyAll=function(t){return function(){return r=[],t}}(this),this.reset=function(t){return function(e){var n=t.triggerFor(e);if(null!=n){n.reset();var i=r.indexOf(n);i>-1&&r.splice(i,1)}return t}}(this),this.resetAll=function(t){return function(){return r.each(function(t){t.reset()}),r=[],t}}(this),this.attach=function(t){return function(e){return c.push(e),u||(u=!0,i()),t}}(this),this.detach=function(t){return function(e){var n=c.indexOf(e);return n>-1&&c.splice(n,1),t}}(this);var h=this;return this.scrollDidChange=function(t){return function(){var e=t.scrollElement.innerWidth||t.scrollElement.offsetWidth,n=t.scrollElement.innerHeight||t.scrollElement.offsetHeight,i=t.bindElement.scrollTop?t.bindElement.scrollTop:document.documentElement.scrollTop,s=t.bindElement.scrollLeft?t.bindElement.scrollLeft:document.documentElement.scrollLeft,o=[];r.each(function(t){var r=t.left(),c=t.top();a.left>s?r-=t.xOffset(!0):a.left<s&&(r+=t.xOffset(!1)),a.top>i?c-=t.yOffset(!0):a.top<i&&(c+=t.yOffset(!1)),e>r&&r>=0&&n>c&&c>=0?(t.addClass(t.visibleClass,function(){t.showCallback&&l(t,t.showCallback)}),t.removeClass(t.hiddenClass),t.once&&o.push(t)):(t.addClass(t.hiddenClass),t.removeClass(t.visibleClass,function(){t.hideCallback&&l(t,t.hideCallback)}))}),c.each(function(l){l.call(t,s,i,e,n)}),o.each(function(t){var e=r.indexOf(t);e>-1&&r.splice(e,1)}),a.left=s,a.top=i}}(this),Array.prototype.each=function(t){for(var e=this.length,n=0;e>n;n++){var i=this[n];i&&t(i,n)}},f(t,e,n)}});


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(jQuery) {var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(3);var _createClass3=_interopRequireDefault(_createClass2);__webpack_require__(95);__webpack_require__(96);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/**
 * ImageGallery JS controller.
 */// Use jQuery as $ within this file scope.
var $=jQuery;// Use modaal for the accessible image gallery
/**
 * Class ImageGallery
 */var ImageGallery=function(){/**
     * Class constructor is for binding class properties.
     */function ImageGallery(){(0,_classCallCheck3.default)(this,ImageGallery);}/**
     * This functions is run after all script classes have been instantiated.
     * Use this if you need to access some other script instances before the document ready event.
     */(0,_createClass3.default)(ImageGallery,[{key:'init',value:function init(){}/**
     * Cache dom elements for use in the class's methods
     */},{key:'cache',value:function cache(){// Get all gallery-elements.
this.$galleries=$('.js-image-gallery');// Get all gallery-elements.
this.$galleryItems=$('.js-image-gallery__item');}/**
     * Init all found galleries.
     */},{key:'initGalleries',value:function initGalleries(){var _this=this;if(this.$galleries.length>0){// Go through each gallery and its thumbnail to add them to a data group to separate
// different galleries on one page
this.$galleries.each(function(index,gallery){// Create an aria description div inside of the first gallery - used in all
// galleries on the same page
if(index==0){$(gallery).before('<div id="aria-gallery-description" class="u-sr-only">'+themeData.themeStrings.image_gallery.gallery_aria_tooltip+'</div>');}// Get current gallery's items
var $galleryItems=$(gallery).find('.js-image-gallery__item');// Set an aria description to the image
$galleryItems.attr('aria-describedby','aria-gallery-description');// Add the data group index to every link
$galleryItems.attr('data-group',index);});// Global settings for all gallery items
this.$galleryItems.each(function(index,galleryItem){// Get the alt text
var imageCaption=$(galleryItem).data('accessible-title');// Set the description
$(galleryItem).attr('data-modaal-desc',imageCaption);// Init Modaal for each gallery item
$(galleryItem).modaal({type:'image',background_scroll:false,//eslint-disable-line
close_aria_label:themeData.themeStrings.image_gallery.gallery_close_string,//eslint-disable-line
close_text:themeData.themeStrings.image_gallery.gallery_close_string,//eslint-disable-line
after_open:_this.disableBackgroundItemFocusing,//eslint-disable-line
before_close:_this.setInertToFalse,//eslint-disable-line
overlay_opacity:0.9//eslint-disable-line
});});}}/**
     * A function to make all the items unfocusable except the opened lightbox gallery
     */},{key:'disableBackgroundItemFocusing',value:function disableBackgroundItemFocusing(){// Check the body if modaal-noscroll class is dynamically added, meaning that the gallery is open.
if($('body').hasClass('modaal-noscroll')){// Not cached for the .modaal-wrapper is generated dynamically, and to make sure we get every item here
var allContainers=$('body').children().not('.modaal-wrapper');// Set inert to true on all the containers outside of the modaal-wrapper
allContainers.each(function(index,item){// Small timeout to make sure this applies to everything - without timeout this won't work
window.setTimeout(item.inert=true,100);});}}/**
     * Set inert to false on all items, used after closing the lightbox gallery - this makes the items
     * focusable again.
     */},{key:'setInertToFalse',value:function setInertToFalse(){// Not cached, to make sure we have everything
var allContainers=$('body').children().not('.modaal-wrapper');// Set inert to true on all the containers outside of the modaal-wrapper
allContainers.each(function(index,item){item.inert=false;});}/**
     * Run when the document is ready.
     */},{key:'docReady',value:function docReady(){this.cache();this.initGalleries();}}]);return ImageGallery;}();// Export the class reference.
module.exports=ImageGallery;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {/*!
	Modaal - accessible modals - v0.4.4
	by Humaan, for all humans.
	http://humaan.com
 */
/**
	Modaal jQuery Plugin : Accessible Modals

	==== General Options ===
	type (string) 					: ajax, inline, image, iframe, confirm. Defaults to 'inline'
	content_source (stribg)			: Accepts a string value for your target element, such as '#my-content'. This allows for when trigger element is
										an `<a href="#">` link. Not to be confused with the already existing `source` event.
	animation (string) 				: Fade, expand, down, up. Defaults to 'fade'
	after_callback_delay (integer)	: Specify a delay value for the after open callbacks. This is necessary because with the bundled animations
										have a set duration in the bundled CSS. Specify a delay of the same amount as the animation duration in so
										more accurately fire the after open/close callbacks. Defaults 350, does not apply if animation is 'none',
										after open callbacks are dispatched immediately

	is_locked (boolean)				: Set this to true to disable closing the modal via keypress or clicking the background. Beware that if
										type != 'confirm' there will be no interface to dismiss the modal if is_locked = true, you'd have to
										programmatically arrange to dismiss the modal. Confirm modals are always locked regardless of this option
										Defaults to false

	hide_close (boolean)			: Set this to true to hide the close modal button. Key press and overlay click will still close the modal.
										This method is best used when you want to put a custom close button inside the modal container space.

	background (string)				: Background overlay style. Defaults to '#000'
	overlay_opacity (float) 		: Background overlay transparency. Defaults to 0.8
	overlay_close (boolean)			: Set this to false if you want to disable click to close on overlay background.

	accessible_title (string)		: Accessible title. Default 'Dialog Window'
	start_open (boolean)			: Set this to true to launch the Modaal window immediately on page open
	fullscreen (boolean)			: Set this to true to make the modaal fill the entire screen, false will default to own width/height attributes.
	custom_class (string)			: Fill in this string with a custom class that will be applied to the outer most modal wrapper.

	width (integer)					: Desired width of the modal. Required for iframe type. Defaults to undefined //TODO
	height (integer)				: Desired height of the modal. Required for iframe type. Defaults to undefined //TODO

	background_scroll (boolean)		: Set this to true to enable the page to scroll behind the open modal.

    should_open (boolean|function)  : Boolean or closure that returns a boolean to determine whether to open the modal or not.

	close_text						: String for close button text. Available for localisation and alternative languages to be used.
	close_aria_label				: String for close button aria-label attribute (value that screen readers will read out). Available for localisation and alternative languages to be used.

	=== Events ===
	before_open (function) 			: Callback function executed before modal is opened
	after_open (function)			: Callback function executed after modal is opened
	before_close (function)			: Callback function executed before modal is closed
	after_close (function)			: Callback function executed after modal is closed
	source (function(element, src))	: Callback function executed on the default source, it is intended to transform the
										source (href in an AJAX modal or iframe). The function passes in the triggering element
										as well as the default source depending of the modal type. The default output of the
										function is an untransformed default source.


	=== Confirm Options & Events ===
	confirm_button_text (string)	: Text on the confirm button. Defaults to 'Confirm'
	confirm_cancel_button_text (string) : Text on the confirm modal cancel button. Defaults to 'Cancel'
	confirm_title (string)			: Title for confirm modal. Default 'Confirm Title'
	confirm_content (string)		: HTML content for confirm message
	confirm_callback (function)		: Callback function for when the confirm button is pressed as opposed to cancel
	confirm_cancel_callback (function) : Callback function for when the cancel button is pressed


	=== Gallery Options & Events ===
	gallery_active_class (string)	: Active class applied to the currently active image or image slide in a gallery 'gallery_active_item'
	outer_controls (boolean)		: Set to true to put the next/prev controls outside the Modaal wrapper, at the edges of the browser window.
	before_image_change (function)	: Callback function executed before the image slide changes in a gallery modal. Default function( current_item, incoming_item )
	after_image_change (function)	: Callback function executed after the image slide changes in a gallery modal. Default function ( current_item )


	=== AJAX Options & Events ===
	loading_content (string)		: HTML content for loading message. Default 'Loading &hellip;'
	loading_class (string)			: Class name to be applied while content is loaded via AJAX. Default 'is_loading'
	ajax_error_class (string)		: Class name to be applied when content has failed to load. Default is 'modaal-error'
	ajax_success (function)		 	: Callback for when AJAX content is loaded in


	=== SOCIAL CONTENT ===
	instagram_id (string)			: Unique photo ID for an Instagram photo.

*/
( function( $ ) {

	var modaal_loading_spinner = '<div class="modaal-loading-spinner"><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div></div>'
	
	var Modaal = {
		init : function(options, elem) {
			var self = this;

			self.dom = $('body');

			self.$elem = $(elem);
			self.options = $.extend({}, $.fn.modaal.options, self.$elem.data(), options);
			self.xhr = null;

			// set up the scope
			self.scope = {
				is_open: false,
				id: 'modaal_' + ( new Date().getTime() ) + ( Math.random().toString(16).substring(2) ),
				source: self.options.content_source ? self.options.content_source : self.$elem.attr('href')
			};

			// add scope attribute to trigger element
			self.$elem.attr('data-modaal-scope', self.scope.id);

			// private options
			self.private_options = {
				active_class: 'is_active'
			};

			self.lastFocus = null;
			
			// if is_locked
			if ( self.options.is_locked || self.options.type == 'confirm' || self.options.hide_close ) {
				self.scope.close_btn = '';
			} else {
				self.scope.close_btn = '<button type="button" class="modaal-close" id="modaal-close" aria-label="' + self.options.close_aria_label + '"><span>' + self.options.close_text + '</span></button>';
			}

			// reset animation_speed
			if (self.options.animation === 'none' ){
				self.options.animation_speed = 0;
				self.options.after_callback_delay = 0;
			}

			// On click to open modal
			$(elem).on('click.Modaal', function(e) {
				e.preventDefault();
				self.create_modaal(self, e);
			});

			// Define next/prev buttons
			if (self.options.outer_controls === true) {
				var mod_class = 'outer';
			} else {
				var mod_class = 'inner';
			}
			self.scope.prev_btn = '<button type="button" class="modaal-gallery-control modaal-gallery-prev modaal-gallery-prev-' + mod_class + '" id="modaal-gallery-prev" aria-label="Previous image (use left arrow to change)"><span>Previous Image</span></button>';
			self.scope.next_btn = '<button type="button" class="modaal-gallery-control modaal-gallery-next modaal-gallery-next-' + mod_class + '" id="modaal-gallery-next" aria-label="Next image (use right arrow to change)"><span>Next Image</span></button>';

			// Check for start_open
			if (self.options.start_open === true ){
				self.create_modaal( self );
			}
		},

		// Initial create to determine which content type it requires
		// ----------------------------------------------------------------
		create_modaal : function(self, e) {
			var self = this;
			var source;

			// Save last active state before modal
			self.lastFocus = self.$elem;

			if ( self.options.should_open === false || ( typeof self.options.should_open === 'function' && self.options.should_open() === false ) ) {
				return;
			}

			// CB: before_open
			self.options.before_open.call(self, e);

			switch (self.options.type) {
				case 'inline':
					self.create_basic();
					break;

				case 'ajax':
					source = self.options.source( self.$elem, self.scope.source );
					self.fetch_ajax( source );
					break;

				case 'confirm':
					self.options.is_locked = true;
					self.create_confirm();
					break;

				case 'image':
					self.create_image();
					break;

				case 'iframe':
					source = self.options.source( self.$elem, self.scope.source );
					self.create_iframe( source );
					break;

				case 'video':
					self.create_video(self.scope.source);
					break;

				case 'instagram':
					self.create_instagram();
					break;
			}

			// call events to be watched (click, tab, keyup, keydown etc.)
			self.watch_events();
		},

		// Watching Modal
		// ----------------------------------------------------------------
		watch_events : function() {
			var self = this;

			self.dom.off('click.Modaal keyup.Modaal keydown.Modaal');

			// Body keydown
			self.dom.on('keydown.Modaal', function(e) {
				var key = e.keyCode;
				var target = e.target;

				// look for tab change and reset focus to modal window
				// done in keydown so the check fires repeatedly when you hold the tab key down
				if (key == 9 && self.scope.is_open) {
					if (!$.contains(document.getElementById(self.scope.id), target) ) {
						$('#' + self.scope.id).find('*[tabindex="0"]').focus();
					}
				}
			});

			// Body keyup
			self.dom.on('keyup.Modaal', function(e) {
				var key = e.keyCode;
				var target = e.target;

				if ( (e.shiftKey && e.keyCode == 9) && self.scope.is_open) {
					// Watch for shift + tab key press. if open shift focus to close button.
					if (!$.contains(document.getElementById(self.scope.id), target) ) {
						$('#' + self.scope.id).find('.modaal-close').focus();
					}
				}

				if ( !self.options.is_locked ){
					// On escape key press close modal
					if (key == 27 && self.scope.is_open ) {
						if ( $(document.activeElement).is('input:not(:checkbox):not(:radio)') ) {
							return false;
						}

						self.modaal_close();
						return;
					}
				}

				// is gallery open and images length is > 1
				if ( self.options.type == 'image' ) {
					// arrow left for back
					if (key == 37 && self.scope.is_open && (!$('#' + self.scope.id + ' .modaal-gallery-prev').hasClass('is_hidden')) ) {
						self.gallery_update('prev');
					}
					// arrow right for next
					if (key == 39 && self.scope.is_open && (!$('#' + self.scope.id + ' .modaal-gallery-next').hasClass('is_hidden')) ) {
						self.gallery_update('next');
					}
					return;
				}
			});

			// Body click/touch
			self.dom.on('click.Modaal', function(e) {
				var trigger = $(e.target);

				// General Controls: If it's not locked allow greedy close
				if ( !self.options.is_locked ){
					if ( (self.options.overlay_close && trigger.is('.modaal-inner-wrapper')) || trigger.is('.modaal-close') || trigger.closest('.modaal-close').length ) {
						self.modaal_close();
						return;
					}
				}

				//Confirm Controls
				if ( trigger.is('.modaal-confirm-btn' ) ){
					// if 'OK' button is clicked, run confirm_callback()
					if ( trigger.is('.modaal-ok') ) {
						self.options.confirm_callback.call(self, self.lastFocus);
					}

					if ( trigger.is('.modaal-cancel') ) {
						self.options.confirm_cancel_callback.call(self, self.lastFocus);
					}
					self.modaal_close();
					return;
				}

				// Gallery Controls
				if ( trigger.is( '.modaal-gallery-control' ) ){
					// it not active, don't do nuthin!
					if ( trigger.hasClass('is_hidden') ) {
						return;
					}

					// trigger previous
					if ( trigger.is('.modaal-gallery-prev') ) {
						self.gallery_update('prev');
					}
					// trigger next
					if ( trigger.is('.modaal-gallery-next') ) {
						self.gallery_update('next');
					}
					return;
				}
			});
		},

		// Append markup into DOM
		build_modal : function(content) {
			var self = this;

			// if is instagram
			var igClass = '';
			if ( self.options.type == 'instagram' ) {
				igClass = ' modaal-instagram';
			}

			var wrap_class = (self.options.type == 'video') ? 'modaal-video-wrap' : 'modaal-content';

			/*
				modaal-start_none : fully hidden via display:none;
				modaal-start_fade : hidden via opacity:0
				modaal-start_slidedown : ...

			*/
			var animation_class;
			switch ( self.options.animation ) {
				case 'fade' :
					animation_class = ' modaal-start_fade';
					break;
				case 'slide-down' :
					animation_class = ' modaal-start_slidedown';
					break;
				default :
					animation_class = ' modaal-start_none'
			}

			// fullscreen check
			var fullscreen_class = '';
			if ( self.options.fullscreen ) {
				fullscreen_class = ' modaal-fullscreen';
			}

			// custom class check
			if ( self.options.custom_class !== '' || typeof(self.options.custom_class) !== 'undefined' ) {
				self.options.custom_class = ' ' + self.options.custom_class;
			}

			// if width and heights exists and is typeof number
			var dimensionsStyle = '';
			if ( self.options.width && self.options.height && typeof self.options.width == 'number' && typeof self.options.height == 'number' ) {
				// if width and height exist, and they are both numbers
				dimensionsStyle = ' style="max-width:' + self.options.width + 'px;height:' + self.options.height + 'px;overflow:auto;"';
			} else if ( self.options.width && typeof self.options.width == 'number' ) {
				// if only width
				dimensionsStyle = ' style="max-width:' + self.options.width + 'px;"';
			} else if ( self.options.height && typeof self.options.height == 'number' ) {
				// if only height
				dimensionsStyle = ' style="height:' + self.options.height + 'px;overflow:auto;"';
			}

			// Reset dimensions style (width and height) for certain types
			if ( self.options.type == 'image' || self.options.type == 'video' || self.options.type == 'instagram' || self.options.fullscreen ) {
				dimensionsStyle = '';
			}

			// if is touch
			// this is a bug fix for iOS to allow regular click events on div elements.
			var touchTrigger = '';
			if ( self.is_touch() ) {
				touchTrigger = ' style="cursor:pointer;"'
			}

			var build_markup = '<div class="modaal-wrapper modaal-' + self.options.type + animation_class + igClass + fullscreen_class + self.options.custom_class + '" id="' + self.scope.id + '"><div class="modaal-outer-wrapper"><div class="modaal-inner-wrapper"' + touchTrigger + '>';

					// hide if video
					if (self.options.type != 'video') {
						build_markup += '<div class="modaal-container"' + dimensionsStyle + '>';
					}

					// add the guts of the content
					build_markup +=	'<div class="' + wrap_class + ' modaal-focus" aria-hidden="false" aria-label="' + self.options.accessible_title + ' - ' + self.options.close_aria_label + '" role="dialog">';

							// If it's inline type, we want to clone content instead of dropping it straight in
							if (self.options.type == 'inline') {
								build_markup += '<div class="modaal-content-container" role="document"></div>';
							} else {
								// Drop in the content if it's not inline
								build_markup +=	content;
							}

					// close wrap_class
					build_markup += '</div>' + self.scope.close_btn;

					// hide if video
					if (self.options.type != 'video') {
						build_markup += '</div>';
					}

			// close off modaal-inner-wrapper
			build_markup +=	'</div>';
			
			// If type is image AND outer_controls is true: add gallery next and previous controls.
			if (self.options.type == 'image' && self.options.outer_controls === true) {
				build_markup += self.scope.prev_btn + self.scope.next_btn;
			}

			// close off modaal-wrapper
			build_markup +=	'</div></div>';

			// append ajax modal markup to dom
			if ($('#' + self.scope.id + '_overlay').length < 1) {
				self.dom.append(build_markup);
			}

			// if inline, clone content into space
			if (self.options.type == 'inline') {
				content.appendTo('#' + self.scope.id + ' .modaal-content-container');
			}

			// Trigger overlay show (which triggers modal show)
			self.modaal_overlay('show');
		},

		// Create Basic Inline Modal
		// ----------------------------------------------------------------
		create_basic : function() {
			var self = this;
			var target = $(self.scope.source);
			var content = '';

			if (target.length) {
				content = target.contents().detach();
				target.empty();
			} else {
				content = 'Content could not be loaded. Please check the source and try again.';
			}

			// now push content into markup
			self.build_modal(content);
		},

		// Create Instagram Modal
		// ----------------------------------------------------------------
		create_instagram : function() {
			var self = this;
			var id = self.options.instagram_id;
			var content = '';

			var error_msg = 'Instagram photo couldn\'t be loaded, please check the embed code and try again.';

			self.build_modal('<div class="modaal-content-container' + ( self.options.loading_class != '' ? ' ' + self.options.loading_class : '' ) + '">' + self.options.loading_content + '</div>' );

			// ID exists, is not empty null or undefined.
			if ( id != '' && id !== null && id !== undefined ) {
				// set up oembed url
				var ig_url = 'https://api.instagram.com/oembed?url=http://instagr.am/p/' + id + '/';

				$.ajax({
					url: ig_url,
					dataType: "jsonp",
					cache: false,
					success: function (data) {
						
						// Create temp dom element from which we'll clone into the modaal instance. This is required to bypass the unusual small thumb issue instagram oembed was serving up
						self.dom.append('<div id="temp-ig" style="width:0;height:0;overflow:hidden;">' + data.html + '</div>');
						
						// Check if it has loaded once before.
						// This is to stop the Embeds.process from throwing and error the first time it's being loaded.
						// private_options are individual to a modaal_scope so will not work across multiple scopes when checking if true, only that one item.
						if ( self.dom.attr('data-igloaded') ) {
							window.instgrm.Embeds.process();
						} else {
							// first time it's loaded, let's set a new private option to use next time it's opened.
							self.dom.attr('data-igloaded', 'true');
						}

						// now set location for new content
						// timeout is required as well to bypass the unusual small thumb issue instagram oembed was serving up
						var target = '#' + self.scope.id + ' .modaal-content-container';
						if ( $(target).length > 0) {
							setTimeout(function() {
								$('#temp-ig').contents().clone().appendTo( target );
								$('#temp-ig').remove();
							}, 1000);
						}
						
					},
					error: function() {
						content = error_msg;

						// now set location for new content
						var target = $('#' + self.scope.id + ' .modaal-content-container');
						if ( target.length > 0) {
							target.removeClass( self.options.loading_class ).addClass( self.options.ajax_error_class );
							target.html(content);
						}
					}
				});

			} else {
				content = error_msg;
			}

			return false;
		},

		// Fetch Ajax Data
		// ----------------------------------------------------------------
		fetch_ajax : function(url) {
			var self = this;
			var content = '';

			// If no accessible title, set it to 'Dialog Window'
			if ( self.options.accessible_title == null ) {
				self.options.accessible_title = 'Dialog Window'
			}

			if ( self.xhr !== null ){
				self.xhr.abort();
				self.xhr = null;
			}

			self.build_modal('<div class="modaal-content-container' + ( self.options.loading_class != '' ? ' ' + self.options.loading_class : '' ) + '">' + self.options.loading_content + '</div>' );

			self.xhr = $.ajax(url, {
				success: function(data) {
					// content fetch is successful so push it into markup
					var target = $('#' + self.scope.id).find('.modaal-content-container');
					if ( target.length > 0){
						target.removeClass( self.options.loading_class );
						target.html( data );

						self.options.ajax_success.call(self, target);
					}
				},
				error: function( xhr ) {
					// There were some errors so return an error message
					if ( xhr.statusText == 'abort' ){
						return;
					}

					var target = $('#' + self.scope.id + ' .modaal-content-container');
					if ( target.length > 0){
						target.removeClass( self.options.loading_class ).addClass( self.options.ajax_error_class );
						target.html( 'Content could not be loaded. Please check the source and try again.' );
					}
				}
			});
		},

		// Create Confirm Modal
		// ----------------------------------------------------------------
		create_confirm : function() {
			var self = this;
			var content;

			content = '<div class="modaal-content-container">' +
					'<h1 id="modaal-title">' + self.options.confirm_title + '</h1>' +
					'<div class="modaal-confirm-content">' + self.options.confirm_content + '</div>' +
						'<div class="modaal-confirm-wrap">' +
							'<button type="button" class="modaal-confirm-btn modaal-ok" aria-label="Confirm">' + self.options.confirm_button_text + '</button>' +
							'<button type="button" class="modaal-confirm-btn modaal-cancel" aria-label="Cancel">' + self.options.confirm_cancel_button_text + '</button>' +
						'</div>' +
					'</div>' +
				'</div>';

			// now push content into markup
			self.build_modal(content);
		},

		// Create Image/Gallery Modal
		// ----------------------------------------------------------------
		create_image : function() {
			var self = this;
			var content;

			var modaal_image_markup = '';
			var gallery_total;
			
			// If has group attribute
			if ( self.$elem.is('[data-group]') || self.$elem.is('[rel]') ) {

				// find gallery groups
				var use_group = self.$elem.is('[data-group]');
				var gallery_group = use_group ? self.$elem.attr('data-group') : self.$elem.attr('rel');
				var gallery_group_items = use_group ? $('[data-group="' + gallery_group + '"]') : $('[rel="' + gallery_group + '"]');

				// remove any previous active attribute to any in the group
				gallery_group_items.removeAttr('data-gallery-active', 'is_active');
				// add active attribute to the item clicked
				self.$elem.attr('data-gallery-active', 'is_active');

				// how many in the grouping are there (-1 to connect with each function starting with 0)
				gallery_total = gallery_group_items.length - 1;

				// prepare array for gallery data
				var gallery = [];

				// start preparing markup
				modaal_image_markup = '<div class="modaal-gallery-item-wrap">';

				// loop each grouping item and push it into our gallery array
				gallery_group_items.each(function(i, item) {
					// setup default content
					var img_src = '';
					var img_alt = '';
					var img_description = '';
					var img_active = false;
					var img_src_error = false;

					var data_modaal_desc = item.getAttribute('data-modaal-desc');
					var data_item_active = item.getAttribute('data-gallery-active');

					// if item has inline custom source, use that instead of href. Fall back to href if available.
					if ( $(item).attr('data-modaal-content-source') ) {
						img_src = $(item).attr('data-modaal-content-source');
					} else if ( $(item).attr('href') ) {
						img_src = $(item).attr('href');
					} else if ( $(item).attr('src') ) {
						img_src = $(item).attr('src');
					} else {
						img_src = 'trigger requires href or data-modaal-content-source attribute';
						img_src_error = true;
					}

					// Does it have a modaal description
					if ( data_modaal_desc != '' && data_modaal_desc !== null && data_modaal_desc !== undefined ) {
						img_alt = data_modaal_desc;
						img_description = '<div class="modaal-gallery-label"><span class="modaal-accessible-hide">Image ' + (i+1) + ' - </span>' + data_modaal_desc.replace(/</g, "&lt;").replace(/>/g, "&gt;") + '</div>'
					} else {
						img_description = '<div class="modaal-gallery-label"><span class="modaal-accessible-hide">Image ' + (i+1) + '</span></div>';
					}

					// is it the active item
					if ( data_item_active ) {
						img_active = true
					}

					// set new object for values we want
					var gallery_item = {
						'url': img_src,
						'alt': img_alt,
						'rawdesc': data_modaal_desc,
						'desc': img_description,
						'active': img_active,
						'src_error': img_src_error
					};

					// push object into gallery array
					gallery.push( gallery_item );
				});

				// now loop through all items in the gallery and build up the markup
				for (var i = 0; i < gallery.length; i++) {
					// Set default active class, then check if array item active is true and update string for class
					var is_active = '';
					var aria_label = gallery[i].rawdesc ? 'Image: ' + gallery[i].rawdesc : 'Image ' + i + ' no description';

					if ( gallery[i].active ) {
						is_active = ' ' + self.private_options.active_class;
					}

					// if gallery item has source error, output message rather than undefined image
					var image_output = gallery[i].src_error ? gallery[i].url : '<img src="' + gallery[i].url + '" alt=" " style="width:100%">';

					// for each item build up the markup
					modaal_image_markup += '<div class="modaal-gallery-item gallery-item-' + i + is_active + '" aria-label="' + aria_label + '">' +
						image_output + gallery[i].desc +
					'</div>';
				}

				// Close off the markup for the gallery
				modaal_image_markup += '</div>';

				// Add next and previous buttons if outside
				if (self.options.outer_controls != true) {
					modaal_image_markup += self.scope.prev_btn + self.scope.next_btn;
				}
			} else {
				// This is only a single gallery item so let's grab the necessary values

				// define the source, check if content_source option exists, and use that or fall back to href.
				var this_img_src;
				var img_src_error = false;
				if ( self.$elem.attr('data-modaal-content-source') ) {
					this_img_src = self.$elem.attr('data-modaal-content-source');
				} else if ( self.$elem.attr('href') ) {
					this_img_src = self.$elem.attr('href');
				} else if ( self.$elem.attr('src') ) {
					this_img_src = self.$elem.attr('src');
				} else {
					this_img_src = 'trigger requires href or data-modaal-content-source attribute';
					img_src_error = true;
				}

				var this_img_alt_txt = '';
				var this_img_alt = '';
				var aria_label = '';

				if ( self.$elem.attr('data-modaal-desc') ) {
					aria_label = self.$elem.attr('data-modaal-desc');
					this_img_alt_txt = self.$elem.attr('data-modaal-desc');
					this_img_alt = '<div class="modaal-gallery-label"><span class="modaal-accessible-hide">Image - </span>' + this_img_alt_txt.replace(/</g, "&lt;").replace(/>/g, "&gt;") + '</div>';
				} else {
					aria_label = "Image with no description";
				}

				// if image item has source error, output message rather than undefined image
				var image_output = img_src_error ? this_img_src : '<img src="' + this_img_src + '" alt=" " style="width:100%">';

				// build up the html
				modaal_image_markup = '<div class="modaal-gallery-item is_active" aria-label="' + aria_label + '">' +
					image_output + this_img_alt +
				'</div>';
			}

			// Update content variable
			content = modaal_image_markup;

			// now push content into markup
			self.build_modal(content);

			// setup next & prev buttons
			if ( $('.modaal-gallery-item.is_active').is('.gallery-item-0') ) {
				$('.modaal-gallery-prev').hide();
			}
			if ( $('.modaal-gallery-item.is_active').is('.gallery-item-' + gallery_total) ) {
				$('.modaal-gallery-next').hide();
			}
		},

		// Gallery Change Image
		// ----------------------------------------------------------------
		gallery_update : function(direction) {
			var self = this;
			var this_gallery = $('#' + self.scope.id);
			var this_gallery_item = this_gallery.find('.modaal-gallery-item');
			var this_gallery_total = this_gallery_item.length - 1;

			// if single item, don't proceed
			if ( this_gallery_total == 0 ) {
				return false;
			}

			var prev_btn = this_gallery.find('.modaal-gallery-prev'),
				next_btn = this_gallery.find('.modaal-gallery-next');

			var duration = 250;

			var new_img_w = 0,
				new_img_h = 0;

			// CB: Before image change
			var current_item = this_gallery.find( '.modaal-gallery-item.' + self.private_options.active_class ),
				incoming_item = ( direction == 'next' ? current_item.next( '.modaal-gallery-item' ) : current_item.prev( '.modaal-gallery-item' ) );
			self.options.before_image_change.call(self, current_item, incoming_item);

			// stop change if at start of end
			if ( direction == 'prev' && this_gallery.find('.gallery-item-0').hasClass('is_active') ) {
				return false;
			} else if ( direction == 'next' && this_gallery.find('.gallery-item-' + this_gallery_total).hasClass('is_active') ) {
				return false;
			}


			// lock dimensions
			current_item.stop().animate({
				opacity: 0
			}, duration, function(){
				// Move to appropriate image
				incoming_item.addClass('is_next').css({
					'position': 'absolute',
					'display': 'block',
					'opacity': 0
				});

				// Collect doc width
				var doc_width = $(document).width();
				var width_threshold = doc_width > 1140 ? 280 : 50;

				// start toggle to 'is_next'
				new_img_w = this_gallery.find('.modaal-gallery-item.is_next').width();
				new_img_h = this_gallery.find('.modaal-gallery-item.is_next').height();

				var new_natural_w = this_gallery.find('.modaal-gallery-item.is_next img').prop('naturalWidth');
				var new_natural_h = this_gallery.find('.modaal-gallery-item.is_next img').prop('naturalHeight');

				// if new image is wider than doc width
				if ( new_natural_w > (doc_width - width_threshold) ) {
					// set new width just below doc width
					new_img_w = doc_width - width_threshold;

					// Set temp widths so we can calulate the correct height;
					this_gallery.find('.modaal-gallery-item.is_next').css({ 'width': new_img_w });
					this_gallery.find('.modaal-gallery-item.is_next img').css({ 'width': new_img_w });

					// Set new height variable
					new_img_h = this_gallery.find('.modaal-gallery-item.is_next').find('img').height();
				} else {
					// new img is not wider than screen, so let's set the new dimensions
					new_img_w = new_natural_w;
					new_img_h = new_natural_h;
				}

				// resize gallery region
				this_gallery.find('.modaal-gallery-item-wrap').stop().animate({
					'width': new_img_w,
					'height': new_img_h
				}, duration, function() {
					// hide old active image
					current_item.removeClass(self.private_options.active_class + ' ' + self.options.gallery_active_class).removeAttr('style');
					current_item.find('img').removeAttr('style');

					// show new image
					incoming_item.addClass(self.private_options.active_class + ' ' + self.options.gallery_active_class).removeClass('is_next').css('position','');

					// animate in new image (now has the normal is_active class
					incoming_item.stop().animate({
						opacity: 1
					}, duration, function(){
						$(this).removeAttr('style').css({
							'width': '100%'
						});
						$(this).find('img').css('width', '100%');

						// remove dimension lock
						this_gallery.find('.modaal-gallery-item-wrap').removeAttr('style');

						// CB: After image change
						self.options.after_image_change.call( self, incoming_item );
					});

					// Focus on the new gallery item
					this_gallery.find('.modaal-gallery-item').removeAttr('tabindex');
					this_gallery.find('.modaal-gallery-item.' + self.private_options.active_class + '').attr('tabindex', '0').focus();

					// hide/show next/prev
					if ( this_gallery.find('.modaal-gallery-item.' + self.private_options.active_class).is('.gallery-item-0') ) {
						prev_btn.stop().animate({
							opacity: 0
						}, 150, function(){
							$(this).hide();
						});
					} else {
						prev_btn.stop().css({
							'display': 'block',
							'opacity': prev_btn.css('opacity')
						}).animate({
							opacity: 1
						}, 150);
					}
					if ( this_gallery.find('.modaal-gallery-item.' + self.private_options.active_class).is('.gallery-item-' + this_gallery_total) ) {
						next_btn.stop().animate({
							opacity: 0
						}, 150, function(){
							$(this).hide();
						});
					} else {
						next_btn.stop().css({
							'display': 'block',
							'opacity': prev_btn.css('opacity')
						}).animate({
							opacity: 1
						}, 150);
					}
				});
			});
		},

		// Create Video Modal
		// ----------------------------------------------------------------
		create_video : function(url) {
			var self = this;
			var content;

			// video markup
			content = '<iframe src="' + url + '" class="modaal-video-frame" frameborder="0" allowfullscreen></iframe>';

			// now push content into markup
			self.build_modal('<div class="modaal-video-container">' + content + '</div>');
		},

		// Create iFrame Modal
		// ----------------------------------------------------------------
		create_iframe : function(url) {
			var self = this;
			var content;

			if ( self.options.width !== null || self.options.width !== undefined || self.options.height !== null || self.options.height !== undefined ) {
				// video markup
				content = '<iframe src="' + url + '" class="modaal-iframe-elem" frameborder="0" allowfullscreen></iframe>';
			} else {
				content = '<div class="modaal-content-container">Please specify a width and height for your iframe</div>';
			}

			// now push content into markup
			self.build_modal(content);
		},

		// Open Modaal
		// ----------------------------------------------------------------
		modaal_open : function() {
			var self = this;
			var modal_wrapper = $( '#' + self.scope.id );
			var animation_type = self.options.animation;

			if (animation_type === 'none' ){
				modal_wrapper.removeClass('modaal-start_none');
				self.options.after_open.call(self, modal_wrapper);
			}

			// Open with fade
			if (animation_type === 'fade') {
				modal_wrapper.removeClass('modaal-start_fade');
			}

			// Open with slide down
			if (animation_type === 'slide-down') {
				modal_wrapper.removeClass('modaal-start_slide_down');
			}

			var focusTarget = modal_wrapper;

			// Switch focusTarget tabindex (switch from other modal if exists)
			$('.modaal-wrapper *[tabindex=0]').removeAttr('tabindex');

			if ( self.options.type == 'image' ) {
				focusTarget = $('#' + self.scope.id).find('.modaal-gallery-item.' + self.private_options.active_class);

			} else if ( modal_wrapper.find('.modaal-iframe-elem').length ) {
				focusTarget = modal_wrapper.find('.modaal-iframe-elem');

			} else if ( modal_wrapper.find('.modaal-video-wrap').length ) {
				focusTarget = modal_wrapper.find('.modaal-video-wrap');

			} else {
				focusTarget = modal_wrapper.find('.modaal-focus');

			}

			// now set the focus
			focusTarget.attr('tabindex', '0').focus();

			// Run after_open
			if (animation_type !== 'none') {
				// CB: after_open
				setTimeout(function() {
					self.options.after_open.call(self, modal_wrapper)
				}, self.options.after_callback_delay);
			}
		},

		// Close Modal
		// ----------------------------------------------------------------
		modaal_close : function() {
			var self = this;
			var modal_wrapper = $( '#' + self.scope.id );

			// CB: before_close
			self.options.before_close.call(self, modal_wrapper);

			if (self.xhr !== null){
				self.xhr.abort();
				self.xhr = null;
			}

			// Now we close the modal
			if (self.options.animation === 'none' ){
				modal_wrapper.addClass('modaal-start_none');
			}

			// Close with fade
			if (self.options.animation === 'fade') {
				modal_wrapper.addClass('modaal-start_fade');
			}

			// Close with slide up (using initial slide down)
			if (self.options.animation === 'slide-down') {
				modal_wrapper.addClass('modaal-start_slide_down');
			}

			// CB: after_close and remove
			setTimeout(function() {
				// clone inline content back to origin place
				if (self.options.type == 'inline') {
					$('#' + self.scope.id + ' .modaal-content-container').contents().detach().appendTo( self.scope.source )
				}
				// remove markup from dom
				modal_wrapper.remove();
				// CB: after_close
				self.options.after_close.call(self);
				// scope is now closed
				self.scope.is_open = false;

			}, self.options.after_callback_delay);

			// Call overlay hide
			self.modaal_overlay('hide');

			// Roll back to last focus state before modal open. If was closed programmatically, this might not be set
			if (self.lastFocus != null) {
				self.lastFocus.focus();
			}
		},

		// Overlay control (accepts action for show or hide)
		// ----------------------------------------------------------------
		modaal_overlay : function(action) {
			var self = this;

			if (action == 'show') {
				// Modal is open so update scope
				self.scope.is_open = true;

				// set body to overflow hidden if background_scroll is false
				if (! self.options.background_scroll) {
					self.dom.addClass('modaal-noscroll');
				}

				// append modaal overlay
				if ($('#' + self.scope.id + '_overlay').length < 1) {
					self.dom.append('<div class="modaal-overlay" id="' + self.scope.id + '_overlay"></div>');
				}

				// now show
				$('#' + self.scope.id + '_overlay').css('background', self.options.background).stop().animate({
					opacity: self.options.overlay_opacity
				}, self.options.animation_speed, function(){
					// now open the modal
					self.modaal_open();
				});

			} else if (action == 'hide') {

				// now hide the overlay
				$('#' + self.scope.id + '_overlay').stop().animate({
					opacity: 0
				}, self.options.animation_speed, function(){
					// remove overlay from dom
					$(this).remove();

					// remove body overflow lock
					self.dom.removeClass('modaal-noscroll');
				});
			}
		},

		// Check if is touch
		// ----------------------------------------------------------------
		is_touch : function() {
			return 'ontouchstart' in window || navigator.maxTouchPoints;
		}
	};

	// Define default object to store
	var modaal_existing_selectors = [];

	// Declare the modaal jQuery method
	// ------------------------------------------------------------
	$.fn.modaal = function(options) {
		return this.each(function (i) {
			var existing_modaal = $(this).data('modaal');

			if ( existing_modaal ){
				// Checking for string value, used for methods
				if (typeof(options) == 'string'){
					switch (options) {
						case 'open':
 							// create the modal
 							existing_modaal.create_modaal(existing_modaal);
							break;
						case 'close':
							existing_modaal.modaal_close();
							break;
					}
				}
			} else {
				// Not a string, so let's setup the modal ready to use
				var modaal = Object.create(Modaal);
				modaal.init(options, this);
				$.data(this, "modaal", modaal);

				// push this select into existing selectors array which is referenced during modaal_dom_observer
				modaal_existing_selectors.push({
					'element': $(this).attr('class'),
					'options': options
				});
			}
		});
	};

	// Default options
	// ------------------------------------------------------------
	$.fn.modaal.options = {

		//General
		type: 'inline',
		content_source: null,
		animation: 'fade',
		animation_speed: 300,
		after_callback_delay: 350,
		is_locked: false,
		hide_close: false,
		background: '#000',
		overlay_opacity: '0.8',
		overlay_close: true,
		accessible_title: 'Dialog Window',
		start_open: false,
		fullscreen: false,
		custom_class: '',
		background_scroll: false,
		should_open: true,
		close_text: 'Close',
		close_aria_label: 'Close (Press escape to close)',
		width: null,
		height: null,

		//Events
		before_open: function(){},
		after_open: function(){},
		before_close: function(){},
		after_close: function(){},
		source: function( element, src ){
			return src;
		},

		//Confirm Modal
		confirm_button_text: 'Confirm', // text on confirm button
		confirm_cancel_button_text: 'Cancel',
		confirm_title: 'Confirm Title', // title for confirm modal
		confirm_content: '<p>This is the default confirm dialog content. Replace me through the options</p>', // html for confirm message
		confirm_callback: function() {},
		confirm_cancel_callback: function() {},


		//Gallery Modal
		gallery_active_class: 'gallery_active_item',
		outer_controls:	false,
		before_image_change: function( current_item, incoming_item ) {},
		after_image_change: function( current_item ) {},

		//Ajax Modal
		loading_content: modaal_loading_spinner,
		loading_class: 'is_loading',
		ajax_error_class: 'modaal-error',
		ajax_success: function(){},

		//Instagram
		instagram_id: null
	};

	// Check and Set Inline Options
	// ------------------------------------------------------------
	function modaal_inline_options(self) {

		// new empty options
		var options = {};
		var inline_options = false;

		// option: type
		if ( self.attr('data-modaal-type') ) {
			inline_options = true;
			options.type = self.attr('data-modaal-type');
		}

		// option: type
		if ( self.attr('data-modaal-content-source') ) {
			inline_options = true;
			options.content_source = self.attr('data-modaal-content-source');
		}

		// option: animation
		if ( self.attr('data-modaal-animation') ) {
			inline_options = true;
			options.animation = self.attr('data-modaal-animation');
		}

		// option: animation_speed
		if ( self.attr('data-modaal-animation-speed') ) {
			inline_options = true;
			options.animation_speed = self.attr('data-modaal-animation-speed');
		}

		// option: after_callback_delay
		if ( self.attr('data-modaal-after-callback-delay') ) {
			inline_options = true;
			options.after_callback_delay = self.attr('data-modaal-after-callback-delay');
		}

		// option: is_locked
		if ( self.attr('data-modaal-is-locked') ) {
			inline_options = true;
			options.is_locked = (self.attr('data-modaal-is-locked') === 'true' ? true : false);
		}

		// option: hide_close
		if ( self.attr('data-modaal-hide-close') ) {
			inline_options = true;
			options.hide_close = (self.attr('data-modaal-hide-close') === 'true' ? true : false);
		}

		// option: background
		if ( self.attr('data-modaal-background') ) {
			inline_options = true;
			options.background = self.attr('data-modaal-background');
		}

		// option: overlay_opacity
		if ( self.attr('data-modaal-overlay-opacity') ) {
			inline_options = true;
			options.overlay_opacity = self.attr('data-modaal-overlay-opacity');
		}

		// option: overlay_close
		if ( self.attr('data-modaal-overlay-close') ) {
			inline_options = true;
			options.overlay_close = (self.attr('data-modaal-overlay-close') === 'false' ? false : true);
		}

		// option: accessible_title
		if ( self.attr('data-modaal-accessible-title') ) {
			inline_options = true;
			options.accessible_title = self.attr('data-modaal-accessible-title');
		}

		// option: start_open
		if ( self.attr('data-modaal-start-open') ) {
			inline_options = true;
			options.start_open = (self.attr('data-modaal-start-open') === 'true' ? true : false);
		}

		// option: fullscreen
		if ( self.attr('data-modaal-fullscreen') ) {
			inline_options = true;
			options.fullscreen = (self.attr('data-modaal-fullscreen') === 'true' ? true : false);
		}

		// option: custom_class
		if ( self.attr('data-modaal-custom-class') ) {
			inline_options = true;
			options.custom_class = self.attr('data-modaal-custom-class');
		}

		// option: close_text
		if ( self.attr('data-modaal-close-text') ) {
			inline_options = true;
			options.close_text = self.attr('data-modaal-close-text');
		}

		// option: close_aria_label
		if ( self.attr('data-modaal-close-aria-label') ) {
			inline_options = true;
			options.close_aria_label = self.attr('data-modaal-close-aria-label');
		}

		// option: background_scroll
		if ( self.attr('data-modaal-background-scroll') ) {
			inline_options = true;
			options.background_scroll = (self.attr('data-modaal-background-scroll') === 'true' ? true : false);
		}

		// option: width
		if ( self.attr('data-modaal-width') ) {
			inline_options = true;
			options.width = parseInt( self.attr('data-modaal-width') );
		}

		// option: height
		if ( self.attr('data-modaal-height') ) {
			inline_options = true;
			options.height = parseInt( self.attr('data-modaal-height') );
		}

		// option: confirm_button_text
		if ( self.attr('data-modaal-confirm-button-text') ) {
			inline_options = true;
			options.confirm_button_text = self.attr('data-modaal-confirm-button-text');
		}

		// option: confirm_cancel_button_text
		if ( self.attr('data-modaal-confirm-cancel-button-text') ) {
			inline_options = true;
			options.confirm_cancel_button_text = self.attr('data-modaal-confirm-cancel-button-text');
		}

		// option: confirm_title
		if ( self.attr('data-modaal-confirm-title') ) {
			inline_options = true;
			options.confirm_title = self.attr('data-modaal-confirm-title');
		}

		// option: confirm_content
		if ( self.attr('data-modaal-confirm-content') ) {
			inline_options = true;
			options.confirm_content = self.attr('data-modaal-confirm-content');
		}

		// option: gallery_active_class
		if ( self.attr('data-modaal-gallery-active-class') ) {
			inline_options = true;
			options.gallery_active_class = self.attr('data-modaal-gallery-active-class');
		}

		// option: loading_content
		if ( self.attr('data-modaal-loading-content') ) {
			inline_options = true;
			options.loading_content = self.attr('data-modaal-loading-content');
		}

		// option: loading_class
		if ( self.attr('data-modaal-loading-class') ) {
			inline_options = true;
			options.loading_class = self.attr('data-modaal-loading-class');
		}

		// option: ajax_error_class
		if ( self.attr('data-modaal-ajax-error-class') ) {
			inline_options = true;
			options.ajax_error_class = self.attr('data-modaal-ajax-error-class');
		}

		// option: start_open
		if ( self.attr('data-modaal-instagram-id') ) {
			inline_options = true;
			options.instagram_id = self.attr('data-modaal-instagram-id');
		}

		// now set it up for the trigger, but only if inline_options is true
		if ( inline_options ) {
			self.modaal(options);
		}
	};

	// On body load (or now, if already loaded), init any modaals defined inline
	// Ensure this is done after $.fn.modaal and default options are declared
	// ----------------------------------------------------------------
	$(function(){

		var single_modaal = $('.modaal');

		// Check for existing modaal elements
		if ( single_modaal.length ) {
			single_modaal.each(function() {
				var self = $(this);
				modaal_inline_options(self);
			});
		}

		// Obvserve DOM mutations for newly added triggers
		var modaal_dom_observer = new MutationObserver(function(mutations) {
			mutations.forEach(function(mutation) {
				if (mutation.addedNodes && mutation.addedNodes.length > 0) {
					// element added to DOM
					var findElement = [].some.call(mutation.addedNodes, function(el) {
						var elm = $(el);
						if ( elm.is('a') || elm.is('button') ) {
							
							if ( elm.hasClass('modaal') ) {
								// is inline Modaal, initialise options
								modaal_inline_options(elm);
							} else {
								// is not inline modaal. Check for existing selector
								modaal_existing_selectors.forEach(function(modaalSelector) {
									if ( modaalSelector.element == elm.attr('class') ) {
										$(elm).modaal( modaalSelector.options );
										return false;
									}
								});
							}

						}
					});
				}
			});
		});
		var observer_config = {
			subtree: true,
			attributes: true,
			childList: true,
			characterData: true
		};

		// pass in the target node, as well as the observer options
		setTimeout(function() {
			modaal_dom_observer.observe(document.body, observer_config);
		}, 500);

	});

} ( jQuery, window, document ) );
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

!function(e){ false?define("inert",e):e()}(function(){"use strict";var o,r,t,i,s,n,e=function(e,t,n){return t&&a(e.prototype,t),n&&a(e,n),e};function a(e,t){for(var n=0;n<t.length;n++){var i=t[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(e,i.key,i)}}function d(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function u(e,t){d(this,u),this._inertManager=t,this._rootElement=e,this._managedNodes=new Set,this._rootElement.hasAttribute("aria-hidden")?this._savedAriaHidden=this._rootElement.getAttribute("aria-hidden"):this._savedAriaHidden=null,this._rootElement.setAttribute("aria-hidden","true"),this._makeSubtreeUnfocusable(this._rootElement),this._observer=new MutationObserver(this._onMutation.bind(this)),this._observer.observe(this._rootElement,{attributes:!0,childList:!0,subtree:!0})}function h(e,t){d(this,h),this._node=e,this._overrodeFocusMethod=!1,this._inertRoots=new Set([t]),this._savedTabIndex=null,this._destroyed=!1,this.ensureUntabbable()}function l(e){if(d(this,l),!e)throw new Error("Missing required argument; InertManager needs to wrap a document.");this._document=e,this._managedNodes=new Map,this._inertRoots=new Map,this._observer=new MutationObserver(this._watchForInert.bind(this)),_(e.head||e.body||e.documentElement),"loading"===e.readyState?e.addEventListener("DOMContentLoaded",this._onDocumentLoaded.bind(this)):this._onDocumentLoaded()}function c(e,t,n){if(e.nodeType==Node.ELEMENT_NODE){var i=e,o=(t&&t(i),i.shadowRoot);if(o)return void c(o,t,o);if("content"==i.localName){for(var o=i,r=o.getDistributedNodes?o.getDistributedNodes():[],s=0;s<r.length;s++)c(r[s],t,n);return}if("slot"==i.localName){for(var o=i,a=o.assignedNodes?o.assignedNodes({flatten:!0}):[],d=0;d<a.length;d++)c(a[d],t,n);return}}for(var u=e.firstChild;null!=u;)c(u,t,n),u=u.nextSibling}function _(e){var t;e.querySelector("style#inert-style, link#inert-style")||((t=document.createElement("style")).setAttribute("id","inert-style"),t.textContent="\n[inert] {\n  pointer-events: none;\n  cursor: default;\n}\n\n[inert], [inert] * {\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n",e.appendChild(t))}"undefined"!=typeof window&&(o=Array.prototype.slice,r=Element.prototype.matches||Element.prototype.msMatchesSelector,t=["a[href]","area[href]","input:not([disabled])","select:not([disabled])","textarea:not([disabled])","button:not([disabled])","details","summary","iframe","object","embed","[contenteditable]"].join(","),e(u,[{key:"destructor",value:function(){this._observer.disconnect(),this._rootElement&&(null!==this._savedAriaHidden?this._rootElement.setAttribute("aria-hidden",this._savedAriaHidden):this._rootElement.removeAttribute("aria-hidden")),this._managedNodes.forEach(function(e){this._unmanageNode(e.node)},this),this._observer=null,this._rootElement=null,this._managedNodes=null,this._inertManager=null}},{key:"_makeSubtreeUnfocusable",value:function(e){var t=this,n=(c(e,function(e){return t._visitNode(e)}),document.activeElement);if(!document.body.contains(e)){for(var i=e,o=void 0;i;){if(i.nodeType===Node.DOCUMENT_FRAGMENT_NODE){o=i;break}i=i.parentNode}o&&(n=o.activeElement)}e.contains(n)&&(n.blur(),n===document.activeElement&&document.body.focus())}},{key:"_visitNode",value:function(e){e.nodeType===Node.ELEMENT_NODE&&((e=e)!==this._rootElement&&e.hasAttribute("inert")&&this._adoptInertRoot(e),(r.call(e,t)||e.hasAttribute("tabindex"))&&this._manageNode(e))}},{key:"_manageNode",value:function(e){e=this._inertManager.register(e,this);this._managedNodes.add(e)}},{key:"_unmanageNode",value:function(e){e=this._inertManager.deregister(e,this);e&&this._managedNodes.delete(e)}},{key:"_unmanageSubtree",value:function(e){var t=this;c(e,function(e){return t._unmanageNode(e)})}},{key:"_adoptInertRoot",value:function(e){var t=this._inertManager.getInertRoot(e);t||(this._inertManager.setInert(e,!0),t=this._inertManager.getInertRoot(e)),t.managedNodes.forEach(function(e){this._manageNode(e.node)},this)}},{key:"_onMutation",value:function(e,t){e.forEach(function(e){var t,n=e.target;"childList"===e.type?(o.call(e.addedNodes).forEach(function(e){this._makeSubtreeUnfocusable(e)},this),o.call(e.removedNodes).forEach(function(e){this._unmanageSubtree(e)},this)):"attributes"===e.type&&("tabindex"===e.attributeName?this._manageNode(n):n!==this._rootElement&&"inert"===e.attributeName&&n.hasAttribute("inert")&&(this._adoptInertRoot(n),t=this._inertManager.getInertRoot(n),this._managedNodes.forEach(function(e){n.contains(e.node)&&t._manageNode(e.node)})))},this)}},{key:"managedNodes",get:function(){return new Set(this._managedNodes)}},{key:"hasSavedAriaHidden",get:function(){return null!==this._savedAriaHidden}},{key:"savedAriaHidden",set:function(e){this._savedAriaHidden=e},get:function(){return this._savedAriaHidden}}]),i=u,e(h,[{key:"destructor",value:function(){var e;this._throwIfDestroyed(),this._node&&this._node.nodeType===Node.ELEMENT_NODE&&(e=this._node,null!==this._savedTabIndex?e.setAttribute("tabindex",this._savedTabIndex):e.removeAttribute("tabindex"),this._overrodeFocusMethod&&delete e.focus),this._node=null,this._inertRoots=null,this._destroyed=!0}},{key:"_throwIfDestroyed",value:function(){if(this.destroyed)throw new Error("Trying to access destroyed InertNode")}},{key:"ensureUntabbable",value:function(){var e;this.node.nodeType===Node.ELEMENT_NODE&&(e=this.node,r.call(e,t)?-1===e.tabIndex&&this.hasSavedTabIndex||(e.hasAttribute("tabindex")&&(this._savedTabIndex=e.tabIndex),e.setAttribute("tabindex","-1"),e.nodeType===Node.ELEMENT_NODE&&(e.focus=function(){},this._overrodeFocusMethod=!0)):e.hasAttribute("tabindex")&&(this._savedTabIndex=e.tabIndex,e.removeAttribute("tabindex")))}},{key:"addInertRoot",value:function(e){this._throwIfDestroyed(),this._inertRoots.add(e)}},{key:"removeInertRoot",value:function(e){this._throwIfDestroyed(),this._inertRoots.delete(e),0===this._inertRoots.size&&this.destructor()}},{key:"destroyed",get:function(){return this._destroyed}},{key:"hasSavedTabIndex",get:function(){return null!==this._savedTabIndex}},{key:"node",get:function(){return this._throwIfDestroyed(),this._node}},{key:"savedTabIndex",set:function(e){this._throwIfDestroyed(),this._savedTabIndex=e},get:function(){return this._throwIfDestroyed(),this._savedTabIndex}}]),s=h,e(l,[{key:"setInert",value:function(e,t){if(t){if(!this._inertRoots.has(e)){t=new i(e,this);if(e.setAttribute("inert",""),this._inertRoots.set(e,t),!this._document.body.contains(e))for(var n=e.parentNode;n;)11===n.nodeType&&_(n),n=n.parentNode}}else this._inertRoots.has(e)&&(this._inertRoots.get(e).destructor(),this._inertRoots.delete(e),e.removeAttribute("inert"))}},{key:"getInertRoot",value:function(e){return this._inertRoots.get(e)}},{key:"register",value:function(e,t){var n=this._managedNodes.get(e);return void 0!==n?n.addInertRoot(t):n=new s(e,t),this._managedNodes.set(e,n),n}},{key:"deregister",value:function(e,t){var n=this._managedNodes.get(e);return n?(n.removeInertRoot(t),n.destroyed&&this._managedNodes.delete(e),n):null}},{key:"_onDocumentLoaded",value:function(){o.call(this._document.querySelectorAll("[inert]")).forEach(function(e){this.setInert(e,!0)},this),this._observer.observe(this._document.body||this._document.documentElement,{attributes:!0,subtree:!0,childList:!0})}},{key:"_watchForInert",value:function(e,t){var i=this;e.forEach(function(e){switch(e.type){case"childList":o.call(e.addedNodes).forEach(function(e){var t;e.nodeType===Node.ELEMENT_NODE&&(t=o.call(e.querySelectorAll("[inert]")),r.call(e,"[inert]")&&t.unshift(e),t.forEach(function(e){this.setInert(e,!0)},i))},i);break;case"attributes":if("inert"!==e.attributeName)return;var t=e.target,n=t.hasAttribute("inert");i.setInert(t,n)}},this)}}]),e=l,HTMLElement.prototype.hasOwnProperty("inert")||(n=new e(document),Object.defineProperty(HTMLElement.prototype,"inert",{enumerable:!0,get:function(){return this.hasAttribute("inert")},set:function(e){n.setInert(this,e)}})))});
//# sourceMappingURL=inert.min.js.map


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(jQuery) {var _typeof2=__webpack_require__(40);var _typeof3=_interopRequireDefault(_typeof2);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(3);var _createClass3=_interopRequireDefault(_createClass2);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/**
 * MapsSection JS controller.
 */// Use jQuery as $ within this file scope.
var $=jQuery;/**
 * Class MapsSection
 */var MapsSection=function(){/**
     * Class constructor is for binding class properties.
     */function MapsSection(){(0,_classCallCheck3.default)(this,MapsSection);}/**
     * This functions is run after all script classes have been instantiated.
     * Use this if you need to access some other script instances before the document ready event.
     */(0,_createClass3.default)(MapsSection,[{key:'init',value:function init(){}/**
     * Cache dom elements for use in the class's methods
     */},{key:'cache',value:function cache(){// Get all google-map-elements.
this.$mapElements=$('.js-google-map');}/**
     * Init all found galleries.
     */},{key:'initGoogleMaps',value:function initGoogleMaps(){// Return early if no map elements found.
if(!this.$mapElements.length){return;};// Return early if Google Maps API has not loaded.
if(!('google'in window&&(typeof google==='undefined'?'undefined':(0,_typeof3.default)(google))==='object'&&(0,_typeof3.default)(google.maps)==='object')){console.warn('Google Maps API not loaded');return;};// Get the link string from the localized variable. Use fallback if variable not found.
var linkText=void 0;if(typeof dptMapsSection!=='undefined'&&typeof dptMapsSection.link_string!=='undefined'){linkText=dptMapsSection.link_string;}else{linkText='Open in Google Maps';}this.$mapElements.each(function(index,mapEl){// Get location data.
var locationInfo={};locationInfo.lat=mapEl.getAttribute('data-lat');locationInfo.lng=mapEl.getAttribute('data-lng');// Return early if locationInfo is not set
if(!locationInfo.lat||!locationInfo.lng){return;}// Popoulate position object.
var position={lat:parseFloat(locationInfo.lat),lng:parseFloat(locationInfo.lng)};// Initialize the Map.
var map=new google.maps.Map(mapEl,{center:position,zoom:15,streetViewControl:false});// Add the location marker
var marker=new google.maps.Marker({position:position,map:map});// Define infowindow content
var contentString='<div>\n                <a href="http://www.google.com/maps/place/'+locationInfo.lat+','+locationInfo.lng+'">'+linkText+'</a>\n            </div>';var infowindow=new google.maps.InfoWindow({content:contentString});marker.addListener('click',function(){infowindow.open(map,marker);});});}/**
     * Run when the document is ready.
     */},{key:'docReady',value:function docReady(){this.cache();this.initGoogleMaps();}}]);return MapsSection;}();// Export the class reference.
module.exports=MapsSection;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(jQuery) {var _typeof2=__webpack_require__(40);var _typeof3=_interopRequireDefault(_typeof2);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(3);var _createClass3=_interopRequireDefault(_createClass2);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/**
 * FbResize JS controller.
 */// Use jQuery as $ within this file scope.
var $=jQuery;/**
 * Class FbResize
 */var FbResize=function(){/**
     * Class constructor is for binding class properties.
     */function FbResize(){(0,_classCallCheck3.default)(this,FbResize);this.reParse=null;}/**
     * This functions is run after all script classes have been instantiated.
     * Use this if you need to access some other script instances before the document ready event.
     */(0,_createClass3.default)(FbResize,[{key:'init',value:function init(){}/**
     * Cache dom elements for use in the class's methods
     */},{key:'cache',value:function cache(){// Get all Facebook page embed elements.
this.$fbPages=$('.fb-page');}/**
     * All common events
     * @return {void}
     */},{key:'events',value:function events(){var _this=this;$(window).resize(function(){// Ideally this would be set up with lodash debounce, but for some reason fb resizing does not work then.
_this.reParseFbPages();});}/**
     * Calculate width of all embedded Facebook pages and re-parse them.
     */},{key:'reParseFbPages',value:function reParseFbPages(){// Return early if Facebook SDK has not loaded.
if(!('FB'in window&&(typeof FB==='undefined'?'undefined':(0,_typeof3.default)(FB))==='object'&&(0,_typeof3.default)(FB.XFBML)==='object')){console.warn('Facebook SDK not loaded');return;};// Set up the width attribute for all fb-page elements.
this.$fbPages.each(function(index,element){var width=$(element).parent().width();// The width of the fb page can be max 500 (according to FB documentation).
width=width>500?500:width;$(element).attr('data-width',width);});// Re-parse fb-pages.
FB.XFBML.parse();}/**
     * Run when the document is ready.
     */},{key:'docReady',value:function docReady(){this.cache();this.events();}}]);return FbResize;}();// Export the class reference.
module.exports=FbResize;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(jQuery) {var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(3);var _createClass3=_interopRequireDefault(_createClass2);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/**
 * Comments JS controller.
 */// Use jQuery as $ within this file scope.
var $=jQuery;/**
 * Class Comments
 */var Comments=function(){/**
     * Class constructor is for binding class properties.
     */function Comments(){(0,_classCallCheck3.default)(this,Comments);}/**
     * This functions is run after all script classes have been instantiated.
     * Use this if you need to access some other script instances before the document ready event.
     */(0,_createClass3.default)(Comments,[{key:'init',value:function init(){}/**
     * All comment-related events
     * @return {void}
     */},{key:'events',value:function events(){if(typeof window.DustPress!=='undefined'){if(window.DustPress.Comments){window.DustPress.Comments.addListener(this.dpCommentsStateCb);}}}/**
     * Callback for DustPress Comments state change. Reloads recaptcha if state is `reply` or `success`.
     * @param {string} state      refers to the state commenting is in
     * @param {object} $container the current commenting section as a jQuery object
     */},{key:'dpCommentsStateCb',value:function dpCommentsStateCb(state,$container){// Return early if not reply or success. Success is called after pagination is done.
if(state!=='reply'&&state!=='success'){return;}// Remove onclick attribute set by WP. This is needed to make sure the attribute gets removed also when using
// pagination
if(state==='success'){var $replyLinks=$container.find('.comment-reply-link');$.each($replyLinks,function(idx,link){link.removeAttribute('onclick');});}// Check if the Simple Google ReCaptcha plugin has added the sgr_recaptcha variable. If so reset the recaptcha.
// The captcha will not work if this is not done.
// Disable linting since we cannot rename the sgr_recaptcha variable.
/* eslint-disable */if(typeof sgr_recaptcha!=="undefined"&&typeof sgr_recaptcha.site_key!=="undefined"&&typeof grecaptcha!=="undefined"){/* eslint-enable */// Set a short timeout so that the script has time to copy the form before we start manipulating it.
setTimeout(function(){// Get the first sgr-recaptcha element.
var sgrDiv=document.getElementsByClassName('sgr-recaptcha')[0];if(sgrDiv){// Empty the element from any old recaptcha data.
sgrDiv.innerHTML='';// Render recaptcha. Disable linting since we cannot rename the sgr_recaptcha variable.
/* eslint-disable */grecaptcha.render(sgrDiv,{'sitekey':sgr_recaptcha.site_key});/* eslint-enable */}},500);}}},{key:'docReady',/**
     * Run when the document is ready.
     */value:function docReady(){this.events();}}]);return Comments;}();// Export the class reference.
module.exports=Comments;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(jQuery) {var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(3);var _createClass3=_interopRequireDefault(_createClass2);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/**
 * Subscribe controller.
 *
 * This class controls Subscribe areas
 */// Use jQuery as $ within this file scope.
var $=jQuery;/**
 * Class Subscribe
 */module.exports=function(){function Subscribe(){(0,_classCallCheck3.default)(this,Subscribe);this.cached={};}/**
     * Store cached elements for use by the class
     *
     * @type {Object}
     */(0,_createClass3.default)(Subscribe,[{key:'cache',/**
     * Cache dom elements for use in the class's methods
     */value:function cache(){this.cached.$container=$('.footer-main-layout__item--email-signup');this.cached.$formcontainer=this.cached.$container.find('.email-signup');this.cached.$form=this.cached.$formcontainer.find('.email-signup__form');this.cached.$emailInput=this.cached.$form.find('.email-signup__form__input');this.cached.$errorField=this.cached.$form.find('.email-signup__form__error');}/**
     * Register event listeners
     */},{key:'events',value:function events(){var _this=this;this.cached.$form.on('submit',function(e){return _this.formSubmit(e);});}/**
     * Ran on subscribe form submit
     *
     * @param {Object} e Form submit event object.
     */},{key:'formSubmit',value:function formSubmit(e){var _this2=this;e.preventDefault();// Check disabled status so we dont send multiple times
var disabled=this.cached.$form.attr('disabled');if(!disabled){// Get email value, clear errors and disable the form
var email=this.cached.$emailInput.val();this.cached.$errorField.empty();this.cached.$form.attr('disabled',true);this.cached.$formcontainer.addClass('disabled');// Send the subscribe ajax call
dp('subscribe',{partial:'subscribe-success',data:true,tidy:true,args:{email:email},/**
                 * On success replace the form content with the success message html
                 *
                 * @param {String} html Success html.
                 */success:function success(html){_this2.cached.$formcontainer.html(html);_this2.cached.$formcontainer.removeClass('disabled');},/**
                 * On error remove disabled status and show error msg
                 *
                 * @param {Object} data Error data.
                 */error:function error(data){_this2.cached.$form.removeAttr('disabled');_this2.cached.$formcontainer.removeClass('disabled');_this2.cached.$errorField.text(data.error);}});}}/**
     * Run when the document is ready.
     */},{key:'docReady',value:function docReady(){this.cache();this.events();}}]);return Subscribe;}();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(jQuery) {var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(3);var _createClass3=_interopRequireDefault(_createClass2);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/**
 * BlogTool JS controller.
 */// Use jQuery as $ within this file scope.
var $=jQuery;/**
 * Class BlogTool
 */var BlogTool=function(){function BlogTool(){(0,_classCallCheck3.default)(this,BlogTool);}(0,_createClass3.default)(BlogTool,[{key:'cache',/**
     * Cache dom elements for use in the class's methods
     */value:function cache(){this.$subscribeBtn=$('.js-blog-tool-subscribe');}/**
     * All blog tool related events
     * @return {void}
     */},{key:'events',value:function events(){var _this=this;this.$subscribeBtn.on('click',function(e){_this.subscribe(e);});}},{key:'subscribe',value:function subscribe(e){e.preventDefault();// Get the form.
var $form=$(e.target).closest('.js-blog-tool-form');// Get email.
var email=$form.find('#email').val();// Get form message.
var $message=$form.children('.js-blog-tool-message');if(this.validateEmail(email)){dp('BlogToolSubscribe',{tidy:true,data:true,args:{email:email},success:function success(){$message.text(blogToolStrings.subscription_success);},error:function error(_error){$message.text(blogToolStrings.subscription_error);console.error(_error);}});}else{$message.text(blogToolStrings.invalid_email);}$message.css('display','inline-block');}/**
     * Validate email.
     *
     * @link https://www.w3resource.com/javascript/form/email-validation.php
     * @param {string} email Email address.
     */},{key:'validateEmail',value:function validateEmail(email){if(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)){return true;}return false;}/**
     * Run when the document is ready.
     */},{key:'docReady',value:function docReady(){this.cache();this.events();}}]);return BlogTool;}();// Export the class reference.
module.exports=BlogTool;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _getIterator2=__webpack_require__(103);var _getIterator3=_interopRequireDefault(_getIterator2);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(3);var _createClass3=_interopRequireDefault(_createClass2);var _indicate=__webpack_require__(106);var _indicate2=_interopRequireDefault(_indicate);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/**
 * Class Accordion
 */var Tables=function(){function Tables(){(0,_classCallCheck3.default)(this,Tables);}(0,_createClass3.default)(Tables,[{key:'cache',/**
     * Cache dom elements for use in the class's methods
     */value:function cache(){this.tables=document.querySelectorAll('.tablepress');}/**
     * Initialize table functionalities.
     */},{key:'initTables',value:function initTables(){if(this.tables.length){var indicate=new _indicate2.default(this.tables);// Make tables focusable for scrolling with keyboard.
var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=(0,_getIterator3.default)(indicate.targetElements),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var table=_step.value;table.setAttribute('tabIndex',0);}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}}}/**
     * Run when the document is ready.
     */},{key:'docReady',value:function docReady(){this.cache();this.initTables();}}]);return Tables;}();// Export the class reference.
/**
 * Tables JS controller.
 */module.exports=Tables;

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(104), __esModule: true };

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(63);
__webpack_require__(27);
module.exports = __webpack_require__(105);


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(10);
var get = __webpack_require__(39);
module.exports = __webpack_require__(5).getIterator = function (it) {
  var iterFn = get(it);
  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

!function(t,e){ true?module.exports=e():"function"==typeof define&&define.amd?define(e):t.Indicate=e()}(this,function(){var t=Object.getOwnPropertySymbols,e=Object.prototype.hasOwnProperty,o=Object.prototype.propertyIsEnumerable,i=function(){try{if(!Object.assign)return!1;var t=new String("abc");if(t[5]="de","5"===Object.getOwnPropertyNames(t)[0])return!1;for(var e={},o=0;o<10;o++)e["_"+String.fromCharCode(o)]=o;if("0123456789"!==Object.getOwnPropertyNames(e).map(function(t){return e[t]}).join(""))return!1;var i={};return"abcdefghijklmnopqrst".split("").forEach(function(t){i[t]=t}),"abcdefghijklmnopqrst"===Object.keys(Object.assign({},i)).join("")}catch(t){return!1}}()?Object.assign:function(i,n){for(var r,s,c=function(t){if(null==t)throw new TypeError("Object.assign cannot be called with null or undefined");return Object(t)}(i),a=1;a<arguments.length;a++){for(var h in r=Object(arguments[a]))e.call(r,h)&&(c[h]=r[h]);if(t){s=t(r);for(var p=0;p<s.length;p++)o.call(r,s[p])&&(c[s[p]]=r[s[p]])}}return c},n=function(t){this.options=t};n.check=function(t){return!1};var r=function(t){function e(){t.apply(this,arguments)}return t&&(e.__proto__=t),(e.prototype=Object.create(t&&t.prototype)).constructor=e,e.check=function(t){return"#FFFFFF"!==t.color},e.prototype.create=function(t){this.setFadeColor(t)},e.prototype.update=function(t){this.setFadeColor(t)},e.prototype.setFadeColor=function(t){var e=this.options.color;t.directions.map(function(o){t.fades[o].style.background="linear-gradient(to "+o+", rgba(255,255,255,0) 0%, "+e+" 100%)"})},e}(n),s=function(t,e){var o=t.className[t.className.length-1];t.className+=o&&" "!==o?" "+e:e},c=function(t){function e(){t.apply(this,arguments)}return t&&(e.__proto__=t),(e.prototype=Object.create(t&&t.prototype)).constructor=e,e.prototype.setArrowRotation=function(t,e){"top"===e&&(t.style.transform="rotate(90deg)"),"right"===e&&(t.style.transform="rotate(180deg)"),"bottom"===e&&(t.style.transform="rotate(270deg)")},e.prototype.setArrowPosition=function(t){var e=this.options.arrowPosition;t.directions.map(function(o){"left"!==o&&"right"!==o||(t.arrows[o].style.display="flex",t.arrows[o].style.alignItems="flex-"+e)})},e.prototype.hideDefaultArrows=function(t){s(t,"idc-no-before")},e}(n),a=function(t){function e(){t.apply(this,arguments)}return t&&(e.__proto__=t),(e.prototype=Object.create(t&&t.prototype)).constructor=e,e.check=function(t){return"center"!==t.arrowPosition},e.prototype.create=function(t){this.setArrowPosition(t)},e.prototype.update=function(t){this.setArrowPosition(t)},e}(c),h=function(t){function e(){t.apply(this,arguments)}return t&&(e.__proto__=t),(e.prototype=Object.create(t&&t.prototype)).constructor=e,e.check=function(t){return Boolean(t.arrowUrl)},e.prototype.create=function(t){this.setArrowUrl(t)},e.prototype.update=function(t){this.setArrowUrl(t)},e.prototype.setArrowUrl=function(t){var e=this,o=this.options.arrowUrl;t.directions.map(function(i){var n=t.arrows[i];n.style.backgroundImage="url("+o+")",n.style.backgroundRepeat="no-repeat",n.style.backgroundSize="contain",e.setArrowRotation(n,i),e.setArrowBackgroundPosition(n,i),s(n,"idc-no-before")})},e.prototype.setArrowBackgroundPosition=function(t,e){var o=this.options.arrowPosition;if("center"!==o&&"top"!==e&&"bottom"!==e){if("start"===o||"top"===o)return"left"===e?void(t.style.backgroundPosition="top"):void(t.style.backgroundPosition="bottom");if("end"===o||"bottom"===o){if("left"===e)return void(t.style.backgroundPosition="bottom");t.style.backgroundPosition="top"}}else t.style.backgroundPosition="center"},e}(c),p=function(t){function e(){t.apply(this,arguments)}return t&&(e.__proto__=t),(e.prototype=Object.create(t&&t.prototype)).constructor=e,e.check=function(t){return Boolean(t.arrowMarkup)},e.prototype.create=function(t){this.setArrowMarkup(t)},e.prototype.update=function(t){this.setArrowMarkup(t)},e.prototype.setArrowMarkup=function(t){var e=this,o=this.options.arrowMarkup;t.directions.map(function(i){var n=t.arrows[i];n.innerHTML=o;var r=n.childNodes[0];e.setArrowRotation(r,i),e.setMarkupSize(r),e.hideDefaultArrows(n)}),this.setArrowPosition(t)},e.prototype.setMarkupSize=function(t){var e=this.options.fadeWidth;t.style.width=e,t.style.height=e},e}(c),l=function(t){function e(){t.apply(this,arguments)}return t&&(e.__proto__=t),(e.prototype=Object.create(t&&t.prototype)).constructor=e,e.check=function(t){return"20px"!==t.fadeWidth},e.prototype.create=function(t){this.setFadeWidth(t)},e.prototype.update=function(t){this.setFadeWidth(t)},e.prototype.setFadeWidth=function(t){var e=this;t.directions.map(function(o){"left"!==o&&"right"!==o||(t.fades[o].style.width=e.options.fadeWidth,t.arrows&&(t.arrows[o].style.width=e.options.fadeWidth)),"top"!==o&&"bottom"!==o||(t.fades[o].style.height=e.options.fadeWidth,t.arrows&&(t.arrows[o].style.height=e.options.fadeWidth))})},e}(n),u=function(t,e){var o=" "+e+" ";return(" "+t.className+" ").replace(/[\n\t\r]/g," ").indexOf(o)>-1},f=function(t,e){t.classList.remove(e)},d=function(t){var e=window.getComputedStyle(t);return{top:parseInt(e.borderTop||e.borderTopWidth||0),right:parseInt(e.borderRight||e.borderRightWidth||0),bottom:parseInt(e.borderBottom||e.borderBottomWidth||0),left:parseInt(e.borderLeft||e.borderLeftWidth||0)}},m=function(t){var e=d(t),o={},i=t.getBoundingClientRect();return o.width=i.width-e.left-e.right,o.height=i.height-e.top-e.bottom,o.width=Math.ceil(o.width),o.height=Math.ceil(o.height),o},y={classPrefix:"idc-",active:"idc-active",activeHorizontal:"idc-active-horizontal",activeVeritcal:"idc-active-vertical",element:"idc-element",container:"idc-container",hide:"idc-hide",absolute:"idc-absolute","fade-top":"idc-fade-top","fade-right":"idc-fade-right","fade-bottom":"idc-fade-bottom","fade-left":"idc-fade-left","arrow-top":"idc-arrow-top","arrow-right":"idc-arrow-right","arrow-bottom":"idc-arrow-bottom","arrow-left":"idc-arrow-left"};"remove"in window.Element.prototype||(window.Element.prototype.remove=function(){this.parentNode&&this.parentNode.removeChild(this)});var g=function(t,e){var o=this;this.element=t,this.container=t,this.options=e,this.directions=[],this.fades={},this.arrows={},this.id=998*Math.random()+1,s(this.element,y.element),this.initFunction=function(){return o.init()},this.resizeFunction=function(){return o.resize()},this.scrollFunction=function(){return o.scroll()},this.hook("setup")};g.prototype.init=function(){this.hook("init");var t=this.shouldInitHorizontal(),e=this.shouldInitVertical();window.addEventListener("resize",this.initFunction),(t||e)&&(this.create(),this.resize())},g.prototype.create=function(){this.setDirections(),this.updateFadeElements(),this.updateArrows(),this.addListeners(),this.hideInitial(),this.hook("create"),!this.isHorizontal()&&this.options.horizontal||!this.isVertical()&&this.options.vertical||window.removeEventListener("resize",this.initFunction)},g.prototype.update=function(t){this.options=i(this.options,t),this.setDirections(),this.updateFadeElements(),this.updateArrows(),this.hook("update"),this.resize()},g.prototype.destroy=function(){window.removeEventListener("resize",this.resizeFunction),window.removeEventListener("resize",this.initFunction),this.container.removeEventListener("scroll",this.scrollFunction),this.removeFadeElements(this.directions),this.removeArrows(!0),f(this.element,y.element)},g.prototype.scroll=function(){this.options.horizontal&&this.fades.left&&this.scrollHorizontal(),this.options.vertical&&this.fades.top&&this.scrollVertical()},g.prototype.scrollHorizontal=function(t,e){t?this.hide("left"):this.show("left"),e?this.hide("right"):this.show("right")},g.prototype.scrollVertical=function(t,e){e?this.hide("bottom"):this.show("bottom"),t?this.hide("top"):this.show("top")},g.prototype.resize=function(){var t=this;window.requestAnimationFrame(function(){return t.updateElementPositions()}),this.scroll()},g.prototype.hide=function(t){u(this.fades[t],y.hide)||s(this.fades[t],y.hide);var e=this.arrows[t];e&&!u(e,y.hide)&&s(e,y.hide)},g.prototype.hideInitial=function(){this.fades.top&&this.hide("top"),this.fades.left&&this.hide("left")},g.prototype.show=function(t){u(this.fades[t],y.hide)&&f(this.fades[t],y.hide);var e=this.arrows[t];e&&u(e,y.hide)&&f(e,y.hide)},g.prototype.updateFadeElements=function(){var t=this;this.removeUnnecessaryFadeElements(),this.directions.forEach(function(e,o){t.fades[e]||(t.fades[e]=document.createElement("div"),t.fades[e].className=y["fade-"+e],t.container.appendChild(t.fades[e]))})},g.prototype.removeUnnecessaryFadeElements=function(){!this.options.horizontal&&this.isHorizontal()&&this.removeFadeElements(["left","right"]),!this.options.vertical&&this.isVertical()&&this.removeFadeElements(["top","bottom"])},g.prototype.removeFadeElements=function(t){var e=this;t.forEach(function(t){e.fades[t].remove(),delete e.fades[t]})},g.prototype.updateArrows=function(){var t=this;this.directions.forEach(function(e){t.arrows[e]||(t.arrows[e]=document.createElement("div"),t.arrows[e].className=y["arrow-"+e],t.container.appendChild(t.arrows[e]))}),this.removeArrows(!1)},g.prototype.removeArrows=function(t){var e=this;Object.keys(this.arrows).forEach(function(o){var i=-1===e.directions.indexOf(o);(t||i||!e.options.arrows)&&(e.arrows[o].remove(),delete e.arrows[o])})},g.prototype.addListeners=function(){window.addEventListener("resize",this.resizeFunction),this.element.addEventListener("scroll",this.scrollFunction)},g.prototype.updateElementPositions=function(){this.hook("updateElementPositions")},g.prototype.setDirections=function(){this.directions=[],this.options.horizontal&&this.directions.push("left","right"),this.options.vertical&&this.directions.push("top","bottom")},g.prototype.isHorizontal=function(){return Boolean(this.fades.left)},g.prototype.isVertical=function(){return Boolean(this.fades.top)},g.prototype.hook=function(t){var e=this;this.options.features.forEach(function(o){return o[t]?o[t](e):0})},g.prototype.elementWidth=function(){return m(this.element).width},g.prototype.contentWidth=function(){return this.element.scrollWidth},g.prototype.elementHeight=function(){return m(this.element).height},g.prototype.contentHeight=function(){return this.element.scrollHeight};var v=function(t,e,o){t?u(e,o)||s(e,o):u(e,o)&&f(e,o)},w=function(t){function e(e,o){t.call(this,e,o),this.init()}return t&&(e.__proto__=t),(e.prototype=Object.create(t&&t.prototype)).constructor=e,e.prototype.shouldInitHorizontal=function(){if(this.options.horizontal&&!this.isHorizontal())return this.contentWidth()>this.elementWidth()},e.prototype.shouldInitVertical=function(){if(this.options.vertical&&!this.isVertical())return this.contentHeight()>this.elementHeight()},e.prototype.destroy=function(){this.container.removeEventListener("scroll",this.scrollFunction),t.prototype.destroy.call(this)},e.prototype.clickHorizontal=function(t){var e=this.element.scrollLeft,o=this.elementWidth()/this.options.scrollDenominator;this.element.scrollLeft="right"===t?e+o:e-o},e.prototype.clickVertical=function(t){var e=this.element.scrollTop,o=this.elementHeight()/this.options.scrollDenominator;this.element.scrollTop="bottom"===t?e+o:e-o},e.prototype.scrollHorizontal=function(){var e=this.element.scrollLeft,o=e<this.options.fadeOffset,i=this.elementWidth()+e+this.options.fadeOffset>this.contentWidth();0===e&&i&&this.contentWidth()>this.elementWidth()&&(i=!1),t.prototype.scrollHorizontal.call(this,o,i)},e.prototype.scrollVertical=function(){var e=this.element.scrollTop,o=e<this.options.fadeOffset,i=this.elementHeight()+e+this.options.fadeOffset>this.contentHeight();t.prototype.scrollVertical.call(this,o,i)},e.prototype.resize=function(){this.setContainerActiveClass(),t.prototype.resize.call(this)},e.prototype.setContainerActiveClass=function(){var t=!1,e=!1,o=this.options.horizontal&&this.elementWidth()<this.contentWidth();v(o,this.container,y.activeHorizontal),o&&(t=!0);var i=this.options.vertical&&this.elementHeight()<this.contentHeight();v(i,this.container,y.activeVeritcal),i&&(e=!0),v(t||e,this.container,y.active)},e}(g),b=function(t){function e(e,o){t.call(this,e,o),this.element=e.parentElement,this.container=this.element.parentElement}return t&&(e.__proto__=t),(e.prototype=Object.create(t&&t.prototype)).constructor=e,e.prototype.elementWidth=function(){return m(this.container).width},e.prototype.elementHeight=function(){return m(this.container).height},e}(w),_=function(t){function e(){t.apply(this,arguments)}return t&&(e.__proto__=t),(e.prototype=Object.create(t&&t.prototype)).constructor=e,e.check=function(t){return"none"!==t.maxHeight},e.prototype.create=function(t){this.setMaxHeight(t)},e.prototype.update=function(t){this.setMaxHeight(t)},e.prototype.setMaxHeight=function(t){t instanceof b&&(t.container.style.maxHeight=this.options.maxHeight)},e}(n),k=function(t){function e(){t.apply(this,arguments)}return t&&(e.__proto__=t),(e.prototype=Object.create(t&&t.prototype)).constructor=e,e.check=function(t){return Boolean(t.click)},e.prototype.create=function(t){var e=this;this.listener=function(o){return e.handleClick.call(t,o)},this.updateClickListeners(t)},e.prototype.update=function(t){this.updateClickListeners(t)},e.prototype.destroy=function(t){var e=this;Object.keys(t.fades).forEach(function(o){return t.fades[o].removeEventListener("click",e.listener)}),Object.keys(t.arrows).forEach(function(o){return t.arrows[o].removeEventListener("click",e.listener)})},e.prototype.updateClickListeners=function(t){var e=this;t.directions.forEach(function(o){(t.arrows[o]?t.arrows[o]:t.fades[o]).addEventListener("click",e.listener)})},e.prototype.handleClick=function(t){var e=t.target;"string"!=typeof t.target.className&&(e=t.target.parentElement);var o=e.className.match(/[\w]*($|\s)/)[0].trim();return"left"===o||"right"===o?this.clickHorizontal(o):"top"===o||"bottom"===o?this.clickVertical(o):void 0},e}(n),E=function(t){if(t&&t!==document.body)return"inline"!==window.getComputedStyle(t).display},H=function(t){function e(){t.apply(this,arguments)}return t&&(e.__proto__=t),(e.prototype=Object.create(t&&t.prototype)).constructor=e,e.check=function(t){return!0},e.prototype.setup=function(t){return this._=t,t.options.forceWrapper?this.add():t instanceof b?this.initTable(t):this.initRegular(t)},e.prototype.initTable=function(t){var e=t.element.parentElement,o=Boolean(t.options.absolutePositioning);return o&&E(e)||this.add(),o||E(e)?this.set(e):this.add()},e.prototype.initRegular=function(t){if(t.options.absolutePositioning&&E(t.element))return this.set(t.element);this.add()},e.prototype.getParent=function(){return this._.container.parentElement},e.prototype.update=function(t){var e=t.options.forceWrapper;if(e&&!this.wrapperAdded)return this.add();!e&&this.wrapperAdded&&E(this.getParent())&&this.remove()},e.prototype.destroy=function(){this.wrapperAdded&&this.remove()},e.prototype.add=function(){var t=document.createElement("div");this.getParent().replaceChild(t,this._.container),t.appendChild(this._.container),this.set(t),this.wrapperAdded=!0},e.prototype.set=function(t){f(this._.container,y.container),f(this._.container,y.element),this._.element=this._.container,s(this._.element,y.element),this._.container=t,s(this._.container,y.container),f(this.getParent(),y.container)},e.prototype.remove=function(){if(this._.element===this._.container)return console.warn("Trying to remove the wrapper when none there.");for(var t=this._.container.childNodes,e=0;e<t.length;e++)this.getParent().appendChild(t[e]);this._.container.remove(),this._.container=this._.element,s(this._.element,y.container),this.wrapperAdded=!1},e}(n),z={top:{stretch:function(t,e){return t.width=e.elementWidth()+"px"},left:function(t){return t.left+"px"},top:function(t){return t.top+"px"}},right:{stretch:function(t,e){return t.height=e.elementHeight()+"px"},left:function(t,e){return"calc("+t.left+"px + "+e.elementWidth()+"px - "+e.options.fadeWidth+")"},top:function(t){return t.top+"px"}},bottom:{stretch:function(t,e){return t.width=e.elementWidth()+"px"},left:function(t){return t.left+"px"},top:function(t,e){return"calc("+t.top+"px + "+e.elementHeight()+"px - "+e.options.fadeWidth+")"}},left:{stretch:function(t,e){return t.height=e.elementHeight()+"px"},left:function(t){return t.left+"px"},top:function(t){return t.top+"px"}}},W=function(t){function e(){t.apply(this,arguments)}return t&&(e.__proto__=t),(e.prototype=Object.create(t&&t.prototype)).constructor=e,e.check=function(t){return!0},e.prototype.setup=function(t){return this._=t,t.options.absolutePositioning?this.setActive(t):(o=t.container.parentElement,e=m(e=t.element),o=m(o),e.width===o.width&&e.height===o.height&&t.element===t.container&&E(t.element)?this.setActive(t):void 0);var e,o},e.prototype.setActive=function(t){this.active=!0,s(t.element,y.absolute)},e.prototype.updateElementPositions=function(t){var e=this;if(this.active){var o,i,n=(i=d(o=t.container),{top:Math.floor(o.offsetTop+i.top),left:Math.floor(o.offsetLeft+i.left)});t.directions.forEach(function(o){return e.setElementPosition(t.fades[o],o,n)}),t.directions.forEach(function(o){return e.setElementPosition(t.arrows[o],o,n)})}},e.prototype.setElementPosition=function(t,e,o){if(t){var i=z[e];t.style.top=i.top(o,this._),t.style.left=i.left(o,this._),i.stretch(t.style,this._)}},e}(n),F=function(t){function e(){t.apply(this,arguments)}return t&&(e.__proto__=t),(e.prototype=Object.create(t&&t.prototype)).constructor=e,e.check=function(t){return!0},e.prototype.setup=function(t){"auto"===window.getComputedStyle(t.element).width&&(t.element.style.display="block")},e}(n),O={Color:r,ArrowPosition:a,ArrowUrl:h,ArrowMarkup:p,FadeWidth:l,MaxHeight:_,Click:k,Wrapper:H,AbsolutePositioning:W,Inline:F},A={scrollDenominator:2,color:"#FFFFFF",arrows:!0,arrowPosition:"center",fadeWidth:"20px",fadeOffset:5,horizontal:!0,vertical:!0,maxHeight:void 0,forceWrapper:!1,click:!0,absolutePositioning:!1},P=function(t){i(this,i({},A,t)),this.checkFeatures(),this.initializeFeatures()};function L(t,e){return Math.max(t.documentElement[e],t.body[e])}function j(t){return t.element.contentDocument}P.prototype.update=function(t){i(this,i({},this,t)),this.checkFeatures(),this.initializeFeatures()},P.prototype.checkFeatures=function(){var t=this,e=Object.keys(O).map(function(t){return O[t]});this.features=e.filter(function(e){return e.check(t)})},P.prototype.initializeFeatures=function(){var t=this;this.features=this.features.map(function(e){return new e(t)})};var I=function(t){function e(e,o){t.call(this,e,o),this.connectIframe()}return t&&(e.__proto__=t),(e.prototype=Object.create(t&&t.prototype)).constructor=e,e.prototype.connectIframe=function(){this.container=this.element,this.checkIfIframeContentsAvailable()},e.prototype.shouldInitHorizontal=function(){if(this.options.horizontal)return this.contentWidth()>this.elementWidth()},e.prototype.shouldInitVertical=function(){if(this.options.vertical)return this.contentHeight()>this.elementHeight()},e.prototype.checkIfIframeContentsAvailable=function(){if(this.contentDocument=j(this),"complete"!==!this.contentDocument.readyState)return this.delayUntilContentsAreLoaded();this.setIframeReferences()},e.prototype.delayUntilContentsAreLoaded=function(t){var e=this;if("complete"!==this.contentDocument.readyState)return setTimeout(function(){return e.delayUntilContentsAreLoaded()},300);this.setIframeReferences()},e.prototype.setIframeReferences=function(){this.contentDocument=j(this),this.init()},e.prototype.registerListeners=function(){this.contentDocument.addEventListener("scroll",this.scrollFunction),t.prototype.registerListeners.call(this)},e.prototype.resize=function(){this.contentWidth=this.contentDocument.body.scrollWidth,this.contentHeight=this.contentDocument.body.scrollHeight,t.prototype.resize.call(this)},e.prototype.scrollHorizontal=function(){var e=L(this.contentDocument,"scrollLeft"),o=e<this.options.fadeOffset,i=this.elementWidth()+e+this.options.fadeOffset>this.contentWidth();t.prototype.scrollHorizontal.call(this,o,i)},e.prototype.scrollVertical=function(){var e=L(this.contentDocument,"scrollTop"),o=e<this.options.fadeOffset,i=this.elementHeight()+e+this.options.fadeOffset>this.contentHeight();t.prototype.scrollVertical.call(this,o,i)},e.prototype.clickHorizontal=function(){},e.prototype.clickVertical=function(){},e.prototype.elementWidth=function(){return m(this.container).width},e.prototype.contentWidth=function(){return this.contentDocument.body.scrollWidth},e.prototype.elementHeight=function(){return m(this.container).height},e.prototype.contentHeight=function(){return this.contentDocument.body.scrollHeight},e}(g),x=function(t){function e(e,o){t.call(this,e,o),this.container=this.element,this.registerPostMessageListener()}return t&&(e.__proto__=t),(e.prototype=Object.create(t&&t.prototype)).constructor=e,e.prototype.shouldInitHorizontal=function(){return this.contentWidth()>this.elementWidth()},e.prototype.shouldInitVertical=function(){return this.contentHeight()>this.elementHeight()},e.prototype.registerPostMessageListener=function(){var t=this;window.addEventListener("message",function(e){e.data&&e.data.indicate&&t.getIframeMessage(e)},!1)},e.prototype.getIframeMessage=function(t){var e=t.data;this.contentWidth=e.width,this.contentHeight=e.height,this.scrollLeft=e.offsetLeft,this.scrollTop=e.offsetTop,e.initialized?this.scroll():this.init()},e.prototype.scrollHorizontal=function(){var e=this.scrollLeft<this.options.fadeOffset,o=this.elementWidth()+this.scrollLeft+this.options.fadeOffset>this.contentWidth();t.prototype.scrollHorizontal.call(this,e,o)},e.prototype.scrollVertical=function(){t.prototype.scrollVertical.call(this,this.scrollTop<this.options.fadeOffset,this.elementHeight+this.scrollTop+this.options.fadeOffset>this.contentHeight)},e.prototype.clickHorizontal=function(){},e.prototype.clickVertial=function(){},e}(g),C=function(t,e){"object"!=typeof e&&(e={}),this.targetElements=t,this.instances=[],this.options=new P(e),this.init()};return C.prototype.init=function(){var t=this,e=this.targetElements;e&&(e.length?[].map.call(e,function(e){return t.createInstanceForElement(e)}):this.createInstanceForElement(e))},C.prototype.update=function(t){var e=this;this.options.update(t),this.instances.forEach(function(t){return t.update(e.options)})},C.prototype.destroy=function(){this.instances.forEach(function(t){return t.destroy()})},C.prototype.createInstanceForElement=function(t){switch(String(t.tagName).toLowerCase()){case"iframe":this.instances.push(this.getIframeInstance(t));break;case"table":this.instances.push(new b(t,this.options));break;default:this.instances.push(new w(t,this.options))}},C.prototype.getIframeInstance=function(t){return function(t){return function(t){var e=t.split("/")[0],o=t.split("/")[2];return(window.location.protocol!==e||window.location.host!==o)&&function(t){var e,o=(e=t.split("."))[e.length-2]+"."+e[e.length-1];return document.domain!==o||(document.domain=o,!1)}(o)}(t.getAttribute("src"))}(t)?new x(t,this.options):new I(t,this.options)},C});
//# sourceMappingURL=indicate.umd.js.map


/***/ }),
/* 107 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// main.js